import { gql } from 'apollo-angular'
import { Injectable } from '@angular/core'
import * as Apollo from 'apollo-angular'
export type Maybe<T> = T | null
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] }
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> }
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> }
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
    ID: string
    String: string
    Boolean: boolean
    Int: number
    Float: number
    Base64: any
    Date: any
    /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
    DateTime: any
    /** A field whose value conforms to the standard internet email address format as specified in RFC822: https://www.w3.org/Protocols/rfc822/. */
    EmailAddress: any
    /** A field whose value is an International Bank Account Number (IBAN): https://en.wikipedia.org/wiki/International_Bank_Account_Number. */
    IBAN: any
    JSON: any
}

export type Accessory = {
    __typename?: 'Accessory'
    id: Scalars['ID']
    name: Scalars['String']
    priceIncVAT: Scalars['Float']
    priceExVAT: Scalars['Float']
}

export type AccessoryProposition = {
    __typename?: 'AccessoryProposition'
    id: Scalars['ID']
    investment: Scalars['Float']
    oldPricePerMonthExVAT: Scalars['Float']
    newPricePerMonthExVAT: Scalars['Float']
    priceIncreaseExVAT: Scalars['Float']
    oldPricePerMonthIncVAT: Scalars['Float']
    newPricePerMonthIncVAT: Scalars['Float']
    priceIncreaseIncVAT: Scalars['Float']
}

export type Address = {
    __typename?: 'Address'
    id: Scalars['ID']
    createdAt?: Maybe<Scalars['Date']>
    updatedAt?: Maybe<Scalars['Date']>
    street?: Maybe<Scalars['String']>
    houseNumber?: Maybe<Scalars['Int']>
    houseNumberSuffix?: Maybe<Scalars['String']>
    zipcode?: Maybe<Scalars['String']>
    city?: Maybe<Scalars['String']>
}

export type AddressInput = {
    street?: Maybe<Scalars['String']>
    houseNumber?: Maybe<Scalars['String']>
    houseNumberSuffix?: Maybe<Scalars['String']>
    zipcode?: Maybe<Scalars['String']>
    city?: Maybe<Scalars['String']>
}

export type AfterDeliveryEditionOption = EditionOptionInterface & {
    __typename?: 'AfterDeliveryEditionOption'
    id: Scalars['ID']
    createdAt?: Maybe<Scalars['Date']>
    updatedAt?: Maybe<Scalars['Date']>
    labelId?: Maybe<Scalars['String']>
    fiscalValue?: Maybe<Scalars['Int']>
    default?: Maybe<Scalars['Boolean']>
    option?: Maybe<ConfigurationOption>
    edition?: Maybe<ConfigurationEdition>
    price?: Maybe<Scalars['Float']>
}

export type AllUserProfilesResult = PaginatedResult & {
    __typename?: 'AllUserProfilesResult'
    userProfiles?: Maybe<Array<Maybe<UserProfile>>>
    totalResults?: Maybe<Scalars['Int']>
}

export type AutodiskDeleteResult = {
    __typename?: 'AutodiskDeleteResult'
    success?: Maybe<Scalars['Boolean']>
}

export type AutodiskEdition = {
    __typename?: 'AutodiskEdition'
    id: Scalars['ID']
    createdAt?: Maybe<Scalars['Date']>
    updatedAt?: Maybe<Scalars['Date']>
    autoId?: Maybe<Scalars['Int']>
    configurationEditionIds?: Maybe<Array<Maybe<Scalars['String']>>>
    defaultOptionIds?: Maybe<Array<Maybe<Scalars['Int']>>>
    model?: Maybe<AutodiskModel>
}

export type AutodiskEditionInput = {
    autoId: Scalars['Int']
    modelId: Scalars['ID']
    configurationEditionIds?: Maybe<Array<Maybe<Scalars['String']>>>
    defaultOptionIds?: Maybe<Array<Maybe<Scalars['Int']>>>
    entity: LessorEntity
}

export type AutodiskModel = {
    __typename?: 'AutodiskModel'
    id: Scalars['ID']
    createdAt?: Maybe<Scalars['Date']>
    updatedAt?: Maybe<Scalars['Date']>
    name?: Maybe<Scalars['String']>
    mainProfileId?: Maybe<Scalars['Int']>
    mantelNr?: Maybe<Scalars['Int']>
    configurationModelIds?: Maybe<Array<Maybe<Scalars['String']>>>
    editions?: Maybe<Array<Maybe<AutodiskEdition>>>
}

export type AutodiskModelInput = {
    name: Scalars['String']
    mainProfileId: Scalars['Int']
    mantelNr?: Maybe<Scalars['Int']>
    configurationModelIds?: Maybe<Array<Maybe<Scalars['String']>>>
    entity: LessorEntity
}

export type Bank = {
    __typename?: 'Bank'
    id: Scalars['ID']
    name: Scalars['String']
}

export type BillingAccount = {
    __typename?: 'BillingAccount'
    id: Scalars['ID']
    createdAt?: Maybe<Scalars['Date']>
    updatedAt?: Maybe<Scalars['Date']>
    accountHolder?: Maybe<Scalars['String']>
    iban?: Maybe<Scalars['IBAN']>
    emailAddress?: Maybe<Scalars['EmailAddress']>
}

export type BooleanDealOption = {
    __typename?: 'BooleanDealOption'
    id: Scalars['ID']
    createdAt?: Maybe<Scalars['Date']>
    updatedAt?: Maybe<Scalars['Date']>
    key: Scalars['String']
    labelId: Scalars['String']
    value: Scalars['Boolean']
}

export type BranchAddress = {
    __typename?: 'BranchAddress'
    id: Scalars['ID']
    city?: Maybe<Scalars['String']>
    street?: Maybe<Scalars['String']>
    houseNr?: Maybe<Scalars['String']>
    houseNrSuffix?: Maybe<Scalars['String']>
    zipCode?: Maybe<Scalars['String']>
    country?: Maybe<Scalars['String']>
}

export type Bucket = {
    __typename?: 'Bucket'
    id: Scalars['ID']
    createdAt?: Maybe<Scalars['Date']>
    updatedAt?: Maybe<Scalars['Date']>
    type: BucketType
    name: Scalars['String']
    description?: Maybe<Scalars['String']>
    content: Array<Document>
}

export enum BucketType {
    SignedDealContracts = 'SIGNED_DEAL_CONTRACTS',
}

export type Car = {
    __typename?: 'Car'
    id: Scalars['ID']
    createdAt: Scalars['DateTime']
    updatedAt: Scalars['DateTime']
    VIN?: Maybe<Scalars['String']>
    entity?: Maybe<Lessor>
    licensePlate?: Maybe<Scalars['String']>
    firstRegistrationDate?: Maybe<Scalars['Date']>
    currentMileage: Scalars['Float']
    currentMileageDate?: Maybe<Scalars['Date']>
    orderedDate?: Maybe<Scalars['Date']>
    fiscalValueIncVAT?: Maybe<Scalars['Float']>
    brandName: Scalars['String']
    modelName: Scalars['String']
    editionName: Scalars['String']
    bookValueExVAT?: Maybe<Scalars['Float']>
    marketValueExVAT?: Maybe<Scalars['Float']>
    reportingCode?: Maybe<Scalars['String']>
    currentTire?: Maybe<Tire>
    tireSizeFront?: Maybe<Scalars['String']>
    tireSizeRear?: Maybe<Scalars['String']>
    lastTireChangeDate?: Maybe<Scalars['Date']>
    lastTireChangeBy?: Maybe<Scalars['String']>
    lastTireChangePlace?: Maybe<Scalars['String']>
    nextTireChangeDate?: Maybe<Scalars['Date']>
    ministryOfTransportDate?: Maybe<Scalars['Date']>
    yearOfManufacture?: Maybe<Scalars['Int']>
    options: Array<TeslaOption>
    images?: Maybe<CarImages>
    contracts?: Maybe<Array<Maybe<Contract>>>
    optionsOverwriteAllowedByImporter: Scalars['Boolean']
}

export type CarCollection = PaginatedResult & {
    __typename?: 'CarCollection'
    cars: Array<Car>
    totalResults: Scalars['Int']
}

export type CarFilter = {
    AND?: Maybe<Array<Maybe<CarFilter>>>
    OR?: Maybe<Array<Maybe<CarFilter>>>
    VIN?: Maybe<Scalars['String']>
    licensePlate?: Maybe<Scalars['String']>
    entity?: Maybe<LessorEntity>
    publishedIn?: Maybe<ShopLocale>
}

export type CarHasContractAttachedError = ExpectedError & {
    __typename?: 'CarHasContractAttachedError'
    errorCode: ErrorCode
    carId: Scalars['String']
    contractId: Scalars['String']
}

export type CarImages = {
    __typename?: 'CarImages'
    mainImageUrl?: Maybe<Scalars['String']>
    interiorImageUrl?: Maybe<Scalars['String']>
    exteriorImageUrl?: Maybe<Scalars['String']>
    urlsAdditionalImages: Array<Scalars['String']>
}

export type CarInput = {
    VIN?: Maybe<Scalars['String']>
    entity?: Maybe<LessorEntity>
    licensePlate?: Maybe<Scalars['String']>
    firstRegistrationDate?: Maybe<Scalars['Date']>
    currentMileage?: Maybe<Scalars['Float']>
    currentMileageDate?: Maybe<Scalars['Date']>
    fiscalValueIncVAT?: Maybe<Scalars['Float']>
    brandName?: Maybe<Scalars['String']>
    modelName?: Maybe<Scalars['String']>
    editionName?: Maybe<Scalars['String']>
    bookValueExVAT?: Maybe<Scalars['Float']>
    marketValueExVAT?: Maybe<Scalars['Float']>
    optionCodes?: Maybe<Array<Scalars['String']>>
}

export type CarResult = Car | EntityNotFoundError

export type CarShopChannel = RemarketingChannel & {
    __typename?: 'CarShopChannel'
    id: Scalars['ID']
    locale: ShopLocale
}

export type CarShopPublication = RemarketingPublication & {
    __typename?: 'CarShopPublication'
    id: Scalars['ID']
    createdAt: Scalars['Date']
    updatedAt: Scalars['Date']
    carId: Scalars['String']
    channel: RemarketingChannel
    isContractTakeover: Scalars['Boolean']
    pricingConfigurationId?: Maybe<Scalars['String']>
    shopCarId: Scalars['String']
    licensePlate?: Maybe<Scalars['String']>
    availability?: Maybe<ShopCarAvailability>
    availabilityDate?: Maybe<Scalars['Date']>
    locale: ShopLocale
    bannerLabel?: Maybe<Scalars['String']>
    offerTypes: Array<ShopOfferType>
}

export type CarShopPublicationInput = {
    locale: ShopLocale
    offers: Array<ShopOfferType>
    availabilityDate: Scalars['Date']
    availability: ShopCarAvailability
    bannerLabel?: Maybe<Scalars['String']>
    pricingConfigurationId?: Maybe<Scalars['String']>
    isContractTakeover?: Maybe<Scalars['Boolean']>
}

export type CarShopPublicationResult = CarShopPublication | EntityNotFoundError | RimsOptionNeededError

export type CarSuccessfullyRemoved = {
    __typename?: 'CarSuccessfullyRemoved'
    carId: Scalars['String']
}

export type Check = {
    __typename?: 'Check'
    id: Scalars['String']
    status: Scalars['String']
    result: Scalars['String']
    reports?: Maybe<Array<Maybe<IdReportStatus>>>
    checkPartsNotClear?: Maybe<Array<Maybe<Scalars['String']>>>
}

export type Company = {
    __typename?: 'Company'
    id: Scalars['ID']
    chamberOfCommerceNr?: Maybe<Scalars['String']>
    mainBranch?: Maybe<CompanyBranch>
}

export type CompanyBranch = {
    __typename?: 'CompanyBranch'
    id: Scalars['ID']
    branchNr?: Maybe<Scalars['String']>
    chamberOfCommerceNr?: Maybe<Scalars['String']>
    name?: Maybe<Scalars['String']>
    foundationDate?: Maybe<Scalars['String']>
    registrationDate?: Maybe<Scalars['String']>
    company?: Maybe<Company>
    visitingAddress?: Maybe<BranchAddress>
    postalAddress?: Maybe<BranchAddress>
    isMainBranch?: Maybe<Scalars['Boolean']>
}

export type CompanyInput = {
    chamberOfCommerceNr?: Maybe<Scalars['String']>
    name?: Maybe<Scalars['String']>
    street?: Maybe<Scalars['String']>
    houseNumber?: Maybe<Scalars['Int']>
    houseNumberSuffix?: Maybe<Scalars['String']>
    zipcode?: Maybe<Scalars['String']>
    city?: Maybe<Scalars['String']>
}

export type CompanySearchAddress = {
    __typename?: 'CompanySearchAddress'
    id: Scalars['ID']
    city?: Maybe<Scalars['String']>
    street?: Maybe<Scalars['String']>
    houseNr?: Maybe<Scalars['String']>
    houseNrSuffix?: Maybe<Scalars['String']>
    zipCode?: Maybe<Scalars['String']>
    country?: Maybe<Scalars['String']>
}

export type CompanySearchResult = {
    __typename?: 'CompanySearchResult'
    id: Scalars['ID']
    branchNr?: Maybe<Scalars['String']>
    chamberOfCommerceNr?: Maybe<Scalars['String']>
    name?: Maybe<Scalars['String']>
    address?: Maybe<CompanySearchAddress>
    isMainBranch?: Maybe<Scalars['Boolean']>
}

export type ConfigurationBrand = {
    __typename?: 'ConfigurationBrand'
    id: Scalars['ID']
    createdAt?: Maybe<Scalars['Date']>
    updatedAt?: Maybe<Scalars['Date']>
    name?: Maybe<Scalars['String']>
    labelId?: Maybe<Scalars['String']>
    slug?: Maybe<Scalars['String']>
    models?: Maybe<Array<Maybe<ConfigurationModel>>>
}

export type ConfigurationBrandInput = {
    name?: Maybe<Scalars['String']>
    slug?: Maybe<Scalars['String']>
}

export type ConfigurationBrandResult = ConfigurationBrand | EntityNotFoundError

export type ConfigurationCalculation = {
    __typename?: 'ConfigurationCalculation'
    id: Scalars['ID']
    createdAt: Scalars['Date']
    updatedAt: Scalars['Date']
    name: Scalars['String']
    description?: Maybe<Scalars['String']>
    components?: Maybe<Array<Maybe<PricingConfigurationComponent>>>
}

export type ConfigurationCalculationCollection = PaginatedResult & {
    __typename?: 'ConfigurationCalculationCollection'
    configurationCalculations?: Maybe<Array<Maybe<ConfigurationCalculation>>>
    totalResults?: Maybe<Scalars['Int']>
}

export type ConfigurationCalculationResult = ConfigurationCalculation | EntityNotFoundError

export type ConfigurationEdition = {
    __typename?: 'ConfigurationEdition'
    id: Scalars['ID']
    createdAt?: Maybe<Scalars['Date']>
    updatedAt?: Maybe<Scalars['Date']>
    name?: Maybe<Scalars['String']>
    labelId?: Maybe<Scalars['String']>
    fiscalValue?: Maybe<Scalars['Int']>
    model?: Maybe<ConfigurationModel>
    options?: Maybe<Array<Maybe<EditionOptionInterface>>>
    displayOrder?: Maybe<Scalars['Int']>
    residualValueTable?: Maybe<ResidualValueTable>
    durations?: Maybe<Array<Maybe<Duration>>>
    mileages?: Maybe<Array<Maybe<Mileage>>>
    /** undefined Only available with roles ADMIN */
    documentationFee?: Maybe<Scalars['Int']>
    /** undefined Only available with roles ADMIN */
    interestRate?: Maybe<Scalars['Float']>
    /** undefined Only available with roles ADMIN */
    maintenanceCostPerKm?: Maybe<Scalars['Float']>
    /** undefined Only available with roles ADMIN */
    replacementTransportationCost?: Maybe<Scalars['Int']>
    /** undefined Only available with roles ADMIN */
    proDriveCost?: Maybe<Scalars['Int']>
    /** undefined Only available with roles ADMIN */
    VAT?: Maybe<Scalars['Int']>
    /** undefined Only available with roles ADMIN */
    margin?: Maybe<Scalars['Float']>
    /** undefined Only available with roles ADMIN */
    lessKm?: Maybe<Scalars['Float']>
    /** undefined Only available with roles ADMIN */
    moreKm?: Maybe<Scalars['Float']>
    /** undefined Only available with roles ADMIN */
    privateLeaseLessKm?: Maybe<Scalars['Float']>
    /** undefined Only available with roles ADMIN */
    privateLeaseMoreKm?: Maybe<Scalars['Float']>
    autodiskEdition?: Maybe<AutodiskEdition>
    /** undefined Only available with roles ADMIN */
    calculation?: Maybe<ConfigurationCalculation>
    /** undefined Only available with roles ADMIN */
    usedCarCalculation?: Maybe<ConfigurationCalculation>
    showInConfigurator?: Maybe<Scalars['Boolean']>
    editionLabel?: Maybe<Scalars['String']>
}

export type ConfigurationEditionInput = {
    name?: Maybe<Scalars['String']>
    fiscalValue?: Maybe<Scalars['Int']>
    modelId?: Maybe<Scalars['String']>
    residualValueTableId?: Maybe<Scalars['String']>
    displayOrder?: Maybe<Scalars['Int']>
    documentationFee?: Maybe<Scalars['Int']>
    interestRate?: Maybe<Scalars['Float']>
    maintenanceCostPerKm?: Maybe<Scalars['Float']>
    replacementTransportationCost?: Maybe<Scalars['Int']>
    proDriveCost?: Maybe<Scalars['Int']>
    VAT?: Maybe<Scalars['Int']>
    margin?: Maybe<Scalars['Float']>
    lessKm?: Maybe<Scalars['Float']>
    moreKm?: Maybe<Scalars['Float']>
    privateLeaseLessKm?: Maybe<Scalars['Float']>
    privateLeaseMoreKm?: Maybe<Scalars['Float']>
    configurationCalculationId?: Maybe<Scalars['String']>
    usedCarConfigurationCalculationId?: Maybe<Scalars['String']>
    showInConfigurator?: Maybe<Scalars['Boolean']>
    editionLabel?: Maybe<Scalars['String']>
}

export type ConfigurationEditionOptionInput = {
    optionId?: Maybe<Scalars['String']>
    editionId?: Maybe<Scalars['String']>
    fiscalValue?: Maybe<Scalars['Int']>
    default?: Maybe<Scalars['Boolean']>
    price?: Maybe<Scalars['Float']>
}

export type ConfigurationEditionOptionResult =
    | EditionOption
    | AfterDeliveryEditionOption
    | LeaseEditionOption
    | WheelEditionOption
    | EntityNotFoundError

export enum ConfigurationEditionOptionType {
    AfterDeliveryEditionOption = 'AfterDeliveryEditionOption',
    LeaseEditionOption = 'LeaseEditionOption',
    EditionOption = 'EditionOption',
    WheelEditionOption = 'WheelEditionOption',
}

export type ConfigurationEditionResult = ConfigurationEdition | EntityNotFoundError

export type ConfigurationModel = {
    __typename?: 'ConfigurationModel'
    id: Scalars['ID']
    createdAt?: Maybe<Scalars['Date']>
    updatedAt?: Maybe<Scalars['Date']>
    name?: Maybe<Scalars['String']>
    labelId?: Maybe<Scalars['String']>
    slug?: Maybe<Scalars['String']>
    editions?: Maybe<Array<Maybe<ConfigurationEdition>>>
    brand?: Maybe<ConfigurationBrand>
    autodiskModel?: Maybe<AutodiskModel>
}

export type ConfigurationModelInput = {
    name?: Maybe<Scalars['String']>
    slug?: Maybe<Scalars['String']>
    brandId?: Maybe<Scalars['String']>
}

export type ConfigurationModelResult = ConfigurationModel | EntityNotFoundError

export type ConfigurationOption = {
    __typename?: 'ConfigurationOption'
    id: Scalars['ID']
    createdAt?: Maybe<Scalars['Date']>
    updatedAt?: Maybe<Scalars['Date']>
    type?: Maybe<Scalars['String']>
    name?: Maybe<Scalars['String']>
    manufacturerCode?: Maybe<Scalars['String']>
    displayOrder: Scalars['Int']
}

export type ConfigurationOptionInput = {
    name?: Maybe<Scalars['String']>
    type?: Maybe<Scalars['String']>
    manufacturerCode?: Maybe<Scalars['String']>
    displayOrder?: Maybe<Scalars['Int']>
}

export type ConfigurationOptionResult = ConfigurationOption | EntityNotFoundError

export type ConfigurationPricing = {
    __typename?: 'ConfigurationPricing'
    fiscalValue: Scalars['Int']
    leasingPriceExVAT: Scalars['Float']
    leasingPriceIncVAT: Scalars['Float']
}

export enum ConfigurationType {
    Paint = 'paint',
    Interior = 'interior',
    Interior2 = 'interior2',
    Autopilot = 'autopilot',
    Seating = 'seating',
    Spoiler = 'spoiler',
    Carboninterior = 'carboninterior',
    Accessories = 'accessories',
    Roof = 'roof',
    Rims = 'rims',
    Rearfacingseats = 'rearfacingseats',
    Towhitch = 'towhitch',
    EigenRisicoVerlaging = 'eigenRisicoVerlaging',
    SteeringWheel = 'steeringWheel',
}

export type Contract = {
    __typename?: 'Contract'
    id: Scalars['ID']
    createdAt?: Maybe<Scalars['Date']>
    updatedAt?: Maybe<Scalars['Date']>
    leasingType?: Maybe<LeasingType>
    /** @deprecated Not necessary according to operations. */
    contractType?: Maybe<Scalars['String']>
    lessor?: Maybe<Lessor>
    lessee?: Maybe<ContractLessee>
    driver?: Maybe<ContractDriver>
    car?: Maybe<Car>
    mileage?: Maybe<Scalars['Int']>
    duration?: Maybe<Scalars['Int']>
    startDate?: Maybe<Scalars['Date']>
    endDate?: Maybe<Scalars['Date']>
    pricePerMonthExVAT?: Maybe<Scalars['Float']>
    pricePerMonthIncVAT?: Maybe<Scalars['Float']>
    moreKmPrice?: Maybe<Scalars['Float']>
    lessKmPrice?: Maybe<Scalars['Float']>
    winterTires?: Maybe<Scalars['Boolean']>
    contractNumber?: Maybe<Scalars['Int']>
    /** undefined Only available with roles ADMIN */
    remarks?: Maybe<Scalars['String']>
    status?: Maybe<ContractStatus>
    /** undefined Only available with roles ADMIN */
    leasewiseStatus?: Maybe<Scalars['String']>
    deductible?: Maybe<Scalars['Int']>
    windowBreakDeductible?: Maybe<Scalars['Int']>
    fsd?: Maybe<Scalars['Boolean']>
    fsdGrowthModel?: Maybe<Scalars['Boolean']>
    fsdGrowthFee?: Maybe<Scalars['Float']>
    billedUntil?: Maybe<Scalars['Date']>
    propositions: Array<Proposition>
    downpayment?: Maybe<Scalars['Float']>
    mileageAtContractStart: Scalars['Float']
    accountManager?: Maybe<UserProfile>
    paymentSummary?: Maybe<PaymentSummary>
    attachments: Array<ContractAttachment>
    premiumConnectivity?: Maybe<Scalars['Boolean']>
}

export type ContractAttachment = {
    __typename?: 'ContractAttachment'
    id: Scalars['ID']
    createdAt?: Maybe<Scalars['Date']>
    updatedAt?: Maybe<Scalars['Date']>
    name: Scalars['String']
    type?: Maybe<ContractAttachmentType>
    url: Scalars['String']
}

export enum ContractAttachmentType {
    SignedContract = 'SIGNED_CONTRACT',
    ChamberOfCommerceDocument = 'CHAMBER_OF_COMMERCE_DOCUMENT',
    CreditCheck = 'CREDIT_CHECK',
    GeneralTermsAndConditions = 'GENERAL_TERMS_AND_CONDITIONS',
    SignedContractWithGeneralTermsAndConditions = 'SIGNED_CONTRACT_WITH_GENERAL_TERMS_AND_CONDITIONS',
    Other = 'OTHER',
}

export type ContractCarFilter = {
    id?: Maybe<Scalars['ID']>
    VIN?: Maybe<Scalars['String']>
    licensePlateNumber?: Maybe<Scalars['String']>
}

export type ContractCollection = PaginatedResult & {
    __typename?: 'ContractCollection'
    contracts?: Maybe<Array<Maybe<Contract>>>
    totalResults?: Maybe<Scalars['Int']>
}

export type ContractCompany = {
    __typename?: 'ContractCompany'
    id: Scalars['ID']
    chamberOfCommerceNr?: Maybe<Scalars['String']>
    name: Scalars['String']
    emailAddress?: Maybe<Scalars['String']>
    phonenumber?: Maybe<Scalars['String']>
    postalAddress?: Maybe<Address>
    visitingAddress?: Maybe<Address>
}

export type ContractDriver = Driver & {
    __typename?: 'ContractDriver'
    id: Scalars['ID']
    firstName?: Maybe<Scalars['String']>
    fullName?: Maybe<Scalars['String']>
    emailAddress?: Maybe<Scalars['String']>
    workPhonenumber?: Maybe<Scalars['String']>
    mobilePhonenumber?: Maybe<Scalars['String']>
    address?: Maybe<Address>
}

export type ContractDriverFilter = {
    name_contains?: Maybe<Scalars['String']>
    email_contains?: Maybe<Scalars['String']>
    userId?: Maybe<Scalars['String']>
}

export type ContractFilter = {
    AND?: Maybe<ContractFilter>
    OR?: Maybe<ContractFilter>
    car?: Maybe<ContractCarFilter>
    lessee?: Maybe<ContractLesseeFilter>
    driver?: Maybe<ContractDriverFilter>
    status?: Maybe<ContractStatus>
    entity?: Maybe<LessorEntity>
    hasAttachments?: Maybe<Scalars['Boolean']>
}

export type ContractInput = {
    entity?: Maybe<LessorEntity>
    mileage?: Maybe<Scalars['Int']>
    duration?: Maybe<Scalars['Int']>
    startDate?: Maybe<Scalars['Date']>
    endDate?: Maybe<Scalars['Date']>
    pricePerMonthExVAT?: Maybe<Scalars['Float']>
    contractType?: Maybe<Scalars['String']>
    leasingType?: Maybe<LeasingType>
    moreKm?: Maybe<Scalars['Float']>
    lessKm?: Maybe<Scalars['Float']>
    VIN?: Maybe<Scalars['String']>
    lessee?: Maybe<LesseeInput>
    driver?: Maybe<DriverInput>
    phonenumber?: Maybe<Scalars['String']>
    contractNumber?: Maybe<Scalars['Int']>
    winterTires?: Maybe<Scalars['Boolean']>
    tires?: Maybe<Scalars['Boolean']>
    remarks?: Maybe<Scalars['String']>
    leasewiseStatus?: Maybe<Scalars['String']>
    status?: Maybe<ContractStatus>
    yearOfManufacture?: Maybe<Scalars['Date']>
    fsd?: Maybe<Scalars['Boolean']>
    fsdGrowthModel?: Maybe<Scalars['Boolean']>
    fsdGrowthFee?: Maybe<Scalars['Float']>
    billedUntil?: Maybe<Scalars['Date']>
    deductible?: Maybe<Scalars['Float']>
    windowBreakDeductible?: Maybe<Scalars['Float']>
    mileageAtContractStart?: Maybe<Scalars['Float']>
    downpayment?: Maybe<Scalars['Float']>
    carId?: Maybe<Scalars['String']>
}

export type ContractLessee = ContractCompany | ContractPerson

export type ContractLesseeFilter = {
    name_contains?: Maybe<Scalars['String']>
}

export type ContractPerson = {
    __typename?: 'ContractPerson'
    id: Scalars['ID']
    emailAddress?: Maybe<Scalars['String']>
    phonenumber?: Maybe<Scalars['String']>
    address?: Maybe<Address>
    name?: Maybe<Scalars['String']>
}

export type ContractRecalculation = {
    __typename?: 'ContractRecalculation'
    id: Scalars['ID']
    oldPricePerMonthExVAT: Scalars['Float']
    newPricePerMonthExVAT: Scalars['Float']
    priceIncreaseExVAT: Scalars['Float']
    oneTimeFeeExVAT: Scalars['Float']
    oldPricePerMonthIncVAT: Scalars['Float']
    newPricePerMonthIncVAT: Scalars['Float']
    priceIncreaseIncVAT: Scalars['Float']
    oneTimeFeeIncVAT: Scalars['Float']
}

export enum ContractStatus {
    Ordered = 'ORDERED',
    Ongoing = 'ONGOING',
    Tobesigned = 'TOBESIGNED',
    Ended = 'ENDED',
}

export type CopyResidualValueInput = {
    name?: Maybe<Scalars['String']>
    residualValueTableId?: Maybe<Scalars['String']>
}

export enum CurrencyCode {
    Aed = 'AED',
    Afn = 'AFN',
    All = 'ALL',
    Amd = 'AMD',
    Ang = 'ANG',
    Aoa = 'AOA',
    Ars = 'ARS',
    Aud = 'AUD',
    Awg = 'AWG',
    Azn = 'AZN',
    Bam = 'BAM',
    Bbd = 'BBD',
    Bdt = 'BDT',
    Bgn = 'BGN',
    Bhd = 'BHD',
    Bif = 'BIF',
    Bmd = 'BMD',
    Bnd = 'BND',
    Bob = 'BOB',
    Bov = 'BOV',
    Brl = 'BRL',
    Bsd = 'BSD',
    Btn = 'BTN',
    Bwp = 'BWP',
    Byn = 'BYN',
    Bzd = 'BZD',
    Cad = 'CAD',
    Cdf = 'CDF',
    Che = 'CHE',
    Chf = 'CHF',
    Chw = 'CHW',
    Clf = 'CLF',
    Clp = 'CLP',
    Cny = 'CNY',
    Cop = 'COP',
    Cou = 'COU',
    Crc = 'CRC',
    Cuc = 'CUC',
    Cup = 'CUP',
    Cve = 'CVE',
    Czk = 'CZK',
    Djf = 'DJF',
    Dkk = 'DKK',
    Dop = 'DOP',
    Dzd = 'DZD',
    Egp = 'EGP',
    Ern = 'ERN',
    Etb = 'ETB',
    Eur = 'EUR',
    Fjd = 'FJD',
    Fkp = 'FKP',
    Gbp = 'GBP',
    Gel = 'GEL',
    Ghs = 'GHS',
    Gip = 'GIP',
    Gmd = 'GMD',
    Gnf = 'GNF',
    Gtq = 'GTQ',
    Gyd = 'GYD',
    Hkd = 'HKD',
    Hnl = 'HNL',
    Hrk = 'HRK',
    Htg = 'HTG',
    Huf = 'HUF',
    Idr = 'IDR',
    Ils = 'ILS',
    Inr = 'INR',
    Iqd = 'IQD',
    Irr = 'IRR',
    Isk = 'ISK',
    Jmd = 'JMD',
    Jod = 'JOD',
    Jpy = 'JPY',
    Kes = 'KES',
    Kgs = 'KGS',
    Khr = 'KHR',
    Kmf = 'KMF',
    Kpw = 'KPW',
    Krw = 'KRW',
    Kwd = 'KWD',
    Kyd = 'KYD',
    Kzt = 'KZT',
    Lak = 'LAK',
    Lbp = 'LBP',
    Lkr = 'LKR',
    Lrd = 'LRD',
    Lsl = 'LSL',
    Lyd = 'LYD',
    Mad = 'MAD',
    Mdl = 'MDL',
    Mga = 'MGA',
    Mkd = 'MKD',
    Mmk = 'MMK',
    Mnt = 'MNT',
    Mop = 'MOP',
    Mru = 'MRU',
    Mur = 'MUR',
    Mvr = 'MVR',
    Mwk = 'MWK',
    Mxn = 'MXN',
    Mxv = 'MXV',
    Myr = 'MYR',
    Mzn = 'MZN',
    Nad = 'NAD',
    Ngn = 'NGN',
    Nio = 'NIO',
    Nok = 'NOK',
    Npr = 'NPR',
    Nzd = 'NZD',
    Omr = 'OMR',
    Pab = 'PAB',
    Pen = 'PEN',
    Pgk = 'PGK',
    Php = 'PHP',
    Pkr = 'PKR',
    Pln = 'PLN',
    Pyg = 'PYG',
    Qar = 'QAR',
    Ron = 'RON',
    Rsd = 'RSD',
    Rub = 'RUB',
    Rwf = 'RWF',
    Sar = 'SAR',
    Sbd = 'SBD',
    Scr = 'SCR',
    Sdg = 'SDG',
    Sek = 'SEK',
    Sgd = 'SGD',
    Shp = 'SHP',
    Sll = 'SLL',
    Sos = 'SOS',
    Srd = 'SRD',
    Ssp = 'SSP',
    Stn = 'STN',
    Svc = 'SVC',
    Syp = 'SYP',
    Szl = 'SZL',
    Thb = 'THB',
    Tjs = 'TJS',
    Tmt = 'TMT',
    Tnd = 'TND',
    Top = 'TOP',
    Try = 'TRY',
    Ttd = 'TTD',
    Twd = 'TWD',
    Tzs = 'TZS',
    Uah = 'UAH',
    Ugx = 'UGX',
    Usd = 'USD',
    Usn = 'USN',
    Uyi = 'UYI',
    Uyu = 'UYU',
    Uyw = 'UYW',
    Uzs = 'UZS',
    Ves = 'VES',
    Vnd = 'VND',
    Vuv = 'VUV',
    Wst = 'WST',
    Xaf = 'XAF',
    Xag = 'XAG',
    Xau = 'XAU',
    Xba = 'XBA',
    Xbb = 'XBB',
    Xbc = 'XBC',
    Xbd = 'XBD',
    Xcd = 'XCD',
    Xdr = 'XDR',
    Xof = 'XOF',
    Xpd = 'XPD',
    Xpf = 'XPF',
    Xpt = 'XPT',
    Xsu = 'XSU',
    Xts = 'XTS',
    Xua = 'XUA',
    Xxx = 'XXX',
    Yer = 'YER',
    Zar = 'ZAR',
    Zmw = 'ZMW',
    Zwl = 'ZWL',
}

export type CurrentUserPayload = {
    __typename?: 'CurrentUserPayload'
    id: Scalars['ID']
}

export type Deal = {
    __typename?: 'Deal'
    id: Scalars['ID']
    createdAt?: Maybe<Scalars['Date']>
    updatedAt?: Maybe<Scalars['Date']>
    offerAcceptedDate?: Maybe<Scalars['Date']>
    options: Array<DealOption>
    lessor: Lessor
    lessee?: Maybe<Lessee>
    requirements: DealRequirements
    signingPersons: Array<SigningPerson>
    legalDocumentNames: Array<LegalDocumentName>
    driver?: Maybe<DealDriver>
    userId?: Maybe<Scalars['String']>
    creatorId?: Maybe<Scalars['String']>
    remarks?: Maybe<Scalars['String']>
    internalOwnerId?: Maybe<Scalars['String']>
    contact?: Maybe<DealContact>
    billingAccount?: Maybe<BillingAccount>
    pricing: Pricing
    referralCode?: Maybe<Scalars['String']>
    referralProgram?: Maybe<ReferralProgram>
    manufacturerReferralCode?: Maybe<Scalars['String']>
    manufacturerAccountEmailAddress?: Maybe<Scalars['String']>
    assetOwnerComment?: Maybe<Scalars['String']>
    status: Status
    dealType: DealType
    /** undefined Only available with roles ADMIN */
    carId?: Maybe<Scalars['String']>
    brandName?: Maybe<Scalars['String']>
    modelName?: Maybe<Scalars['String']>
    editionName?: Maybe<Scalars['String']>
    locale?: Maybe<DealLocale>
    calculationComponents?: Maybe<Scalars['String']>
    licencePlate?: Maybe<Scalars['String']>
    optionsDescription?: Maybe<Scalars['String']>
    edition?: Maybe<ConfigurationEdition>
}

export type DealBillingInput = {
    accountHolder: Scalars['String']
    iban?: Maybe<Scalars['IBAN']>
    emailAddress?: Maybe<Scalars['EmailAddress']>
}

export type DealCollection = PaginatedResult & {
    __typename?: 'DealCollection'
    deals?: Maybe<Array<Maybe<Deal>>>
    totalResults?: Maybe<Scalars['Int']>
}

export type DealContact = {
    __typename?: 'DealContact'
    id: Scalars['ID']
    createdAt?: Maybe<Scalars['Date']>
    updatedAt?: Maybe<Scalars['Date']>
    firstName?: Maybe<Scalars['String']>
    lastName?: Maybe<Scalars['String']>
    lastNamePrefix?: Maybe<Scalars['String']>
    emailAddress?: Maybe<Scalars['EmailAddress']>
    phonenumber?: Maybe<Scalars['String']>
}

export type DealContactInput = {
    firstName?: Maybe<Scalars['String']>
    lastName?: Maybe<Scalars['String']>
    lastNamePrefix?: Maybe<Scalars['String']>
    emailAddress?: Maybe<Scalars['EmailAddress']>
    phonenumber?: Maybe<Scalars['String']>
}

export type DealContractPdf = {
    __typename?: 'DealContractPdf'
    dealId: Scalars['ID']
    url: Scalars['String']
}

export type DealDriver = Driver & {
    __typename?: 'DealDriver'
    id: Scalars['ID']
    createdAt?: Maybe<Scalars['Date']>
    updatedAt?: Maybe<Scalars['Date']>
    userId: Scalars['String']
    emailAddress?: Maybe<Scalars['String']>
    phonenumber?: Maybe<Scalars['String']>
    address?: Maybe<Address>
    licenseVerified?: Maybe<Scalars['Boolean']>
    firstName?: Maybe<Scalars['String']>
    lastName?: Maybe<Scalars['String']>
    lastNamePrefix?: Maybe<Scalars['String']>
}

export type DealFilter = {
    AND?: Maybe<Array<Maybe<DealFilter>>>
    OR?: Maybe<Array<Maybe<DealFilter>>>
    offerAcceptedDate?: Maybe<Scalars['Date']>
    internalOwnerId?: Maybe<Scalars['String']>
    ownerId?: Maybe<Scalars['String']>
    status?: Maybe<Status>
    kcStatus?: Maybe<InternalStatus>
    kvkStatus?: Maybe<InternalStatus>
    company?: Maybe<LesseeFilter>
    contactEmailAddress_contains?: Maybe<Scalars['String']>
    contactFullname_contains?: Maybe<Scalars['String']>
    driver?: Maybe<DriverFilter>
}

export type DealInput = {
    editionId?: Maybe<Scalars['ID']>
    shopCarId?: Maybe<Scalars['ID']>
    carId?: Maybe<Scalars['ID']>
    pricingConfigurationId?: Maybe<Scalars['ID']>
    referralCode?: Maybe<Scalars['String']>
    lessorAdministrationCode?: Maybe<Scalars['String']>
    pricingConfigurationComponents?: Maybe<Array<Maybe<PricingConfigurationComponentInput>>>
    locale?: Maybe<DealLocale>
    deductible?: Maybe<Scalars['String']>
}

export enum DealLocale {
    NlNl = 'nl_NL',
    NlBe = 'nl_BE',
    FrBe = 'fr_BE',
    DeDe = 'de_DE',
    DaDk = 'da_DK',
    FrFr = 'fr_FR',
}

export type DealOption = BooleanDealOption | SelectableDealOption

export type DealRequirements = {
    __typename?: 'DealRequirements'
    id: Scalars['ID']
    isCompanyRequired?: Maybe<Scalars['Boolean']>
    isDriverRequired?: Maybe<Scalars['Boolean']>
}

export enum DealType {
    ConfigurableCar = 'CONFIGURABLE_CAR',
    ConfiguredCar = 'CONFIGURED_CAR',
}

export enum DeleteDocumentResult {
    Deleted = 'DELETED',
    DocumentIsReadOnly = 'DOCUMENT_IS_READ_ONLY',
    AccessNotGranted = 'ACCESS_NOT_GRANTED',
}

export type Document = {
    __typename?: 'Document'
    id: Scalars['ID']
    createdAt?: Maybe<Scalars['Date']>
    updatedAt?: Maybe<Scalars['Date']>
    name: Scalars['String']
    description?: Maybe<Scalars['String']>
    category: DocumentCategory
    mimeType: Scalars['String']
    readonly: Scalars['Boolean']
    metadata?: Maybe<DocumentMetadata>
    bucketType: BucketType
    bucketId: Scalars['String']
    retrievalUrl: Scalars['String']
}

export enum DocumentCategory {
    SignedDealContract = 'SIGNED_DEAL_CONTRACT',
}

export type DocumentCollection = PaginatedResult & {
    __typename?: 'DocumentCollection'
    documents: Array<Document>
    totalResults?: Maybe<Scalars['Int']>
}

export type DocumentFilter = {
    AND?: Maybe<Array<DocumentFilter>>
    OR?: Maybe<Array<DocumentFilter>>
    bucketType?: Maybe<BucketType>
}

export type DocumentInput = {
    name: Scalars['String']
    description?: Maybe<Scalars['String']>
    content: Scalars['Base64']
    documentUploadToken: Scalars['String']
}

export type DocumentMetadata = PdfMetadata | ImageMetadata | MiscellaneousMetadata

export type DocumentSignature = {
    __typename?: 'DocumentSignature'
    id: Scalars['ID']
    createdAt?: Maybe<Scalars['Date']>
    updatedAt?: Maybe<Scalars['Date']>
    document: Document
    verified: Scalars['Boolean']
    verificationTimestamp?: Maybe<Scalars['Date']>
    verifiedByUserId?: Maybe<Scalars['String']>
}

export type Driver = {
    firstName?: Maybe<Scalars['String']>
    emailAddress?: Maybe<Scalars['String']>
    address?: Maybe<Address>
}

export type DriverFilter = {
    AND?: Maybe<Array<Maybe<DriverFilter>>>
    OR?: Maybe<Array<Maybe<DriverFilter>>>
    emailAddress_contains?: Maybe<Scalars['String']>
    fullName_contains?: Maybe<Scalars['String']>
    licenseVerified?: Maybe<Scalars['Boolean']>
    userId?: Maybe<Scalars['String']>
}

export type DriverInput = {
    firstName?: Maybe<Scalars['String']>
    lastName?: Maybe<Scalars['String']>
    initials?: Maybe<Scalars['String']>
    emailAddress?: Maybe<Scalars['EmailAddress']>
    workPhonenumber?: Maybe<Scalars['String']>
    mobilePhonenumber?: Maybe<Scalars['String']>
    address?: Maybe<AddressInput>
}

export type Duration = {
    __typename?: 'Duration'
    id: Scalars['ID']
    value: Scalars['Int']
    unit: Scalars['String']
}

export type EditionInfo = {
    __typename?: 'EditionInfo'
    model?: Maybe<Scalars['String']>
    edition?: Maybe<Scalars['String']>
    price?: Maybe<Scalars['Int']>
}

export type EditionOption = EditionOptionInterface & {
    __typename?: 'EditionOption'
    id: Scalars['ID']
    createdAt?: Maybe<Scalars['Date']>
    updatedAt?: Maybe<Scalars['Date']>
    labelId?: Maybe<Scalars['String']>
    fiscalValue?: Maybe<Scalars['Int']>
    default?: Maybe<Scalars['Boolean']>
    option?: Maybe<ConfigurationOption>
    edition?: Maybe<ConfigurationEdition>
}

export type EditionOptionInterface = {
    id: Scalars['ID']
    createdAt?: Maybe<Scalars['Date']>
    updatedAt?: Maybe<Scalars['Date']>
    labelId?: Maybe<Scalars['String']>
    fiscalValue?: Maybe<Scalars['Int']>
    default?: Maybe<Scalars['Boolean']>
    option?: Maybe<ConfigurationOption>
    edition?: Maybe<ConfigurationEdition>
}

export type EditionValidation = {
    __typename?: 'EditionValidation'
    valid: Scalars['Boolean']
    errors?: Maybe<Array<Maybe<EditionValidationResult>>>
}

export type EditionValidationResult = {
    __typename?: 'EditionValidationResult'
    message?: Maybe<Scalars['String']>
    code?: Maybe<Scalars['String']>
    faultyOptions?: Maybe<Array<Maybe<Scalars['ID']>>>
}

export type EmailTemplate = {
    __typename?: 'EmailTemplate'
    id: Scalars['ID']
    createdAt?: Maybe<Scalars['Date']>
    updatedAt?: Maybe<Scalars['Date']>
    name: Scalars['String']
    emailTemplateLocales: Array<EmailTemplateLocale>
}

export type EmailTemplateCollection = PaginatedResult & {
    __typename?: 'EmailTemplateCollection'
    emailTemplates?: Maybe<Array<Maybe<EmailTemplate>>>
    totalResults?: Maybe<Scalars['Int']>
}

export type EmailTemplateFilter = {
    name_contains?: Maybe<Scalars['String']>
}

export type EmailTemplateInput = {
    name: Scalars['String']
    emailTemplateLocales: Array<EmailTemplateLocaleInput>
}

export type EmailTemplateLocale = {
    __typename?: 'EmailTemplateLocale'
    id: Scalars['ID']
    createdAt?: Maybe<Scalars['Date']>
    updatedAt?: Maybe<Scalars['Date']>
    locale: WebsiteLocale
    subject: Scalars['String']
    previewText: Scalars['String']
    htmlContent: Scalars['String']
    rawTemplateContent: Scalars['JSON']
}

export type EmailTemplateLocaleInput = {
    id?: Maybe<Scalars['ID']>
    locale: WebsiteLocale
    subject: Scalars['String']
    previewText: Scalars['String']
    htmlContent: Scalars['String']
    rawTemplateContent: Scalars['JSON']
}

export type EndContractProposition = {
    __typename?: 'EndContractProposition'
    id: Scalars['ID']
    oneTimeFeeExVAT: Scalars['Float']
    oneTimeFeeIncVAT: Scalars['Float']
}

export type Entity = {
    __typename?: 'Entity'
    id: Scalars['ID']
    type: EntityType
    name: Scalars['String']
    properties: Array<EntityProperty>
}

export type EntityNotFoundError = ExpectedError & {
    __typename?: 'EntityNotFoundError'
    errorCode: ErrorCode
}

export type EntityProperty = {
    __typename?: 'EntityProperty'
    id: Scalars['ID']
    name: Scalars['String']
    description?: Maybe<Scalars['String']>
}

export type EntityRequirementInput = {
    property: Scalars['String']
    filter: Array<WorkflowEntityRequirementFilter>
}

export enum EntityType {
    User = 'USER',
    Company = 'COMPANY',
    Deal = 'DEAL',
    AuthenticationToken = 'AUTHENTICATION_TOKEN',
    ContractProposition = 'CONTRACT_PROPOSITION',
}

export enum ErrorCode {
    EntityNotFound = 'ENTITY_NOT_FOUND',
    InvalidInputData = 'INVALID_INPUT_DATA',
    RemovalNotAllowed = 'REMOVAL_NOT_ALLOWED',
}

export type Event = {
    __typename?: 'Event'
    id: Scalars['ID']
    timestamp: Scalars['Date']
    type: EventType
    data?: Maybe<Array<EventData>>
    userId?: Maybe<Scalars['String']>
    user?: Maybe<User>
    entityType: EventEntityType
    entityId: Scalars['String']
    entity?: Maybe<EventEntity>
}

export type EventCollection = PaginatedResult & {
    __typename?: 'EventCollection'
    events?: Maybe<Array<Maybe<Event>>>
    totalResults?: Maybe<Scalars['Int']>
}

export type EventData = {
    __typename?: 'EventData'
    property: Scalars['String']
    from?: Maybe<Scalars['String']>
    to?: Maybe<Scalars['String']>
}

export type EventEntity = Contract | Car | EntityNotFoundError

export enum EventEntityType {
    Car = 'CAR',
    Contract = 'CONTRACT',
}

export type EventFilter = {
    AND?: Maybe<Array<Maybe<EventFilter>>>
    OR?: Maybe<Array<Maybe<EventFilter>>>
    entityType?: Maybe<EventEntityType>
    entityId?: Maybe<Scalars['String']>
}

export enum EventType {
    Create = 'CREATE',
    Delete = 'DELETE',
    Update = 'UPDATE',
}

export type ExpectedError = {
    errorCode: ErrorCode
}

export type FsdProposition = {
    __typename?: 'FSDProposition'
    id: Scalars['ID']
    oldPricePerMonthExVAT: Scalars['Float']
    newPricePerMonthExVAT: Scalars['Float']
    priceIncreaseExVAT: Scalars['Float']
    oldPricePerMonthIncVAT: Scalars['Float']
    newPricePerMonthIncVAT: Scalars['Float']
    priceIncreaseIncVAT: Scalars['Float']
    type: FsdPropositionType
}

export enum FsdPropositionType {
    Fixed = 'FIXED',
    Variable = 'VARIABLE',
}

export enum IdCheckResult {
    Clear = 'CLEAR',
    Consider = 'CONSIDER',
    AwaitingResult = 'AWAITING_RESULT',
    NoCheckStarted = 'NO_CHECK_STARTED',
}

export type IdCheckStatus = {
    __typename?: 'IdCheckStatus'
    result: IdCheckResult
    check?: Maybe<Array<Maybe<Check>>>
}

export type IdReportStatus = {
    __typename?: 'IdReportStatus'
    name: Scalars['String']
    status: Scalars['String']
    id: Scalars['String']
    result?: Maybe<Scalars['String']>
    breakdown?: Maybe<Scalars['JSON']>
}

export type IdealSignature = {
    __typename?: 'IdealSignature'
    id: Scalars['ID']
    createdAt?: Maybe<Scalars['Date']>
    updatedAt?: Maybe<Scalars['Date']>
    accountName?: Maybe<Scalars['String']>
    iban?: Maybe<Scalars['IBAN']>
    paymentId?: Maybe<Scalars['String']>
    status?: Maybe<PaymentStatus>
}

export type ImageMetadata = {
    __typename?: 'ImageMetadata'
    sizeInBytes?: Maybe<Scalars['Int']>
    width?: Maybe<Scalars['Int']>
    height?: Maybe<Scalars['Int']>
}

export enum InternalStatus {
    NotStarted = 'NOT_STARTED',
    Accepted = 'ACCEPTED',
    Rejected = 'REJECTED',
}

export type InvalidInputDataError = ExpectedError & {
    __typename?: 'InvalidInputDataError'
    errorCode: ErrorCode
    missingInputProperties: Array<Scalars['String']>
}

export type JsonWebToken = {
    __typename?: 'JsonWebToken'
    userId?: Maybe<Scalars['ID']>
    token?: Maybe<Scalars['String']>
}

export type LeaseEditionOption = EditionOptionInterface & {
    __typename?: 'LeaseEditionOption'
    id: Scalars['ID']
    createdAt?: Maybe<Scalars['Date']>
    updatedAt?: Maybe<Scalars['Date']>
    labelId?: Maybe<Scalars['String']>
    fiscalValue?: Maybe<Scalars['Int']>
    default?: Maybe<Scalars['Boolean']>
    option?: Maybe<ConfigurationOption>
    edition?: Maybe<ConfigurationEdition>
    price?: Maybe<Scalars['Float']>
}

export type LeasewiseOfferStatus = {
    __typename?: 'LeasewiseOfferStatus'
    id: Scalars['ID']
    createdAt?: Maybe<Scalars['Date']>
    updatedAt?: Maybe<Scalars['Date']>
    dealId?: Maybe<Scalars['ID']>
    internetNr?: Maybe<Scalars['Int']>
    status?: Maybe<LeasewiseOfferStatusName>
    error?: Maybe<Scalars['String']>
}

export enum LeasewiseOfferStatusName {
    Pending = 'pending',
    Succeeded = 'succeeded',
    Failed = 'failed',
}

export enum LeasingType {
    Fulloperational = 'FULLOPERATIONAL',
    Private = 'PRIVATE',
    Ready_2Share = 'READY_2_SHARE',
}

export type LegalDocument = {
    __typename?: 'LegalDocument'
    id: Scalars['ID']
    createdAt?: Maybe<Scalars['Date']>
    updatedAt?: Maybe<Scalars['Date']>
    name?: Maybe<Scalars['String']>
    slug?: Maybe<Scalars['String']>
    locale?: Maybe<Scalars['String']>
    content?: Maybe<LegalDocumentContent>
    versions?: Maybe<Array<Maybe<LegalDocumentContent>>>
}

export type LegalDocumentAgreement = {
    __typename?: 'LegalDocumentAgreement'
    id: Scalars['ID']
    createdAt?: Maybe<Scalars['Date']>
    hash?: Maybe<Scalars['String']>
    userId?: Maybe<Scalars['String']>
    variables?: Maybe<Array<Maybe<LegalDocumentAgreementVariable>>>
    title?: Maybe<Scalars['String']>
    body?: Maybe<Scalars['String']>
    agreement?: Maybe<Scalars['String']>
    summary?: Maybe<Scalars['String']>
    name?: Maybe<Scalars['String']>
    slug?: Maybe<Scalars['String']>
    locale?: Maybe<Scalars['String']>
}

export type LegalDocumentAgreementTemplate = {
    __typename?: 'LegalDocumentAgreementTemplate'
    hash?: Maybe<Scalars['String']>
    userId?: Maybe<Scalars['String']>
    variables?: Maybe<Array<Maybe<LegalDocumentAgreementVariable>>>
    title?: Maybe<Scalars['String']>
    body?: Maybe<Scalars['String']>
    agreement?: Maybe<Scalars['String']>
    summary?: Maybe<Scalars['String']>
    name?: Maybe<Scalars['String']>
    slug?: Maybe<Scalars['String']>
    locale?: Maybe<Scalars['String']>
}

export type LegalDocumentAgreementVariable = {
    __typename?: 'LegalDocumentAgreementVariable'
    type?: Maybe<LegalDocumentContentVariable>
    value?: Maybe<Scalars['String']>
}

export type LegalDocumentAgreementVariableInput = {
    type?: Maybe<LegalDocumentContentVariable>
    value?: Maybe<Scalars['String']>
}

export type LegalDocumentContent = {
    __typename?: 'LegalDocumentContent'
    id: Scalars['ID']
    createdAt?: Maybe<Scalars['Date']>
    updatedAt?: Maybe<Scalars['Date']>
    publishedAt?: Maybe<Scalars['Date']>
    archivedAt?: Maybe<Scalars['Date']>
    title?: Maybe<Scalars['String']>
    body?: Maybe<Scalars['String']>
    agreement?: Maybe<Scalars['String']>
    summary?: Maybe<Scalars['String']>
    hash?: Maybe<Scalars['String']>
    variables?: Maybe<Array<Maybe<LegalDocumentContentVariable>>>
    document?: Maybe<LegalDocument>
}

export enum LegalDocumentContentVariable {
    CompanyName = 'companyName',
    CompanyChamberOfCommerce = 'companyChamberOfCommerce',
    FullName = 'fullName',
}

export enum LegalDocumentName {
    PrivateLeaseContractShort = 'private_lease_contract_short',
    PrivacyPolicy = 'privacy_policy',
    TermsAndConditions = 'terms_and_conditions',
    CostOverview = 'cost_overview',
    FolCostOverview = 'fol_cost_overview',
    PrivateLeaseCostOverview = 'private_lease_cost_overview',
    Proviso = 'proviso',
    PrivateLeaseKeurmerk = 'private_lease_keurmerk',
    PrivateLeaseContract = 'private_lease_contract',
    PrivateLeaseTermsAndConditions = 'private_lease_terms_and_conditions',
    PrivateLeasePolicyConditions = 'private_lease_policy_conditions',
    PrivateLeaseIntakeProtocol = 'private_lease_intake_protocol',
    PrivateLeaseContractAddendum = 'private_lease_contract_addendum',
    ServiceMaintenance = 'service_maintenance',
}

export type Lessee = LesseeCompany | LesseePerson

export type LesseeCompany = {
    __typename?: 'LesseeCompany'
    id: Scalars['ID']
    createdAt: Scalars['Date']
    updatedAt: Scalars['Date']
    chamberOfCommerceNr?: Maybe<Scalars['String']>
    name: Scalars['String']
    postalAddress?: Maybe<Address>
    visitingAddress?: Maybe<Address>
    kcStatus: InternalStatus
    kcComment?: Maybe<Scalars['String']>
    kvkStatus: InternalStatus
    kvkComment?: Maybe<Scalars['String']>
}

export type LesseeFilter = {
    name_contains?: Maybe<Scalars['String']>
    chamberOfCommerceNr_contains?: Maybe<Scalars['String']>
}

export type LesseeInput = {
    name?: Maybe<Scalars['String']>
    emailAddress?: Maybe<Scalars['EmailAddress']>
    phonenumber?: Maybe<Scalars['String']>
    chamberOfCommerceNr?: Maybe<Scalars['String']>
    visitingAddress?: Maybe<AddressInput>
    postalAddress?: Maybe<AddressInput>
}

export type LesseePerson = {
    __typename?: 'LesseePerson'
    id: Scalars['ID']
    createdAt: Scalars['Date']
    updatedAt: Scalars['Date']
    userId: Scalars['String']
    emailAddress: Scalars['EmailAddress']
    phonenumber?: Maybe<Scalars['String']>
    address?: Maybe<Address>
    firstName?: Maybe<Scalars['String']>
    lastName?: Maybe<Scalars['String']>
    lastNamePrefix?: Maybe<Scalars['String']>
    kcStatus: InternalStatus
    kcComment?: Maybe<Scalars['String']>
}

export type Lessor = {
    __typename?: 'Lessor'
    id: Scalars['ID']
    createdAt?: Maybe<Scalars['DateTime']>
    updatedAt?: Maybe<Scalars['DateTime']>
    chamberOfCommerceNr?: Maybe<Scalars['String']>
    name?: Maybe<Scalars['String']>
    postalAddress?: Maybe<Address>
    visitingAddress?: Maybe<Address>
}

export enum LessorEntity {
    Mgl1 = 'MGL1',
    Mgl2 = 'MGL2',
    Gmbh = 'GMBH',
    Bvba = 'BVBA',
    Dk = 'DK',
}

export type LoginToken = {
    __typename?: 'LoginToken'
    id?: Maybe<Scalars['ID']>
    createAt?: Maybe<Scalars['Date']>
    token: Scalars['String']
}

export type LoginUrlPayload = {
    __typename?: 'LoginUrlPayload'
    id: Scalars['ID']
    token: Scalars['String']
    url: Scalars['String']
}

export type LookupAddress = {
    __typename?: 'LookupAddress'
    id: Scalars['ID']
    street: Scalars['String']
    city: Scalars['String']
}

export type LookupAddressInput = {
    zipcode: Scalars['String']
    houseNumber?: Maybe<Scalars['String']>
    houseNumberSuffix?: Maybe<Scalars['String']>
}

export type Mileage = {
    __typename?: 'Mileage'
    id: Scalars['ID']
    value?: Maybe<Scalars['Int']>
    unit?: Maybe<Scalars['String']>
}

export type MiscellaneousMetadata = {
    __typename?: 'MiscellaneousMetadata'
    sizeInBytes?: Maybe<Scalars['Int']>
}

export type Mutation = {
    __typename?: 'Mutation'
    /** undefined Only available with roles ADMIN */
    createLoginUrl?: Maybe<LoginUrlPayload>
    exchangeForJsonWebToken?: Maybe<JsonWebToken>
    refreshLoginUrl?: Maybe<Scalars['Boolean']>
    requestLoginEmail?: Maybe<Scalars['Boolean']>
    createGuestToken?: Maybe<JsonWebToken>
    /** undefined Only available with roles ADMIN */
    createJsonWebToken?: Maybe<JsonWebToken>
    signupUser?: Maybe<JsonWebToken>
    /** undefined Only available with roles ADMIN */
    createUser?: Maybe<User>
    /** undefined Only available with roles ADMIN */
    addUserRole?: Maybe<User>
    /** undefined Only available with roles SUPERADMIN */
    setUserRoles?: Maybe<User>
    /** undefined Only available with roles ADMIN */
    setUserTenants?: Maybe<User>
    /** undefined Only available with roles ADMIN */
    removeUserRole?: Maybe<User>
    /** undefined Only available with roles ADMIN */
    deleteUser?: Maybe<Scalars['Boolean']>
    /** undefined Only available with roles ADMIN */
    upsertCar: UpsertCarResult
    /** undefined Only available with roles ADMIN */
    removeCar: RemoveCarResult
    /** undefined Only available with roles ADMIN */
    importCarFromLeasewise: CarResult
    /** undefined Only available with roles ADMIN */
    publishToCarShop: CarShopPublicationResult
    /** undefined Only available with roles ADMIN */
    unpublishRemarketingPublication: UnpublishRemarketingPublicationResult
    updateCompanyCreditscore?: Maybe<Scalars['String']>
    /** undefined Only available with roles ADMIN */
    createBrand?: Maybe<ConfigurationBrand>
    /** undefined Only available with roles ADMIN */
    updateBrand?: Maybe<ConfigurationBrand>
    /** undefined Only available with roles ADMIN */
    removeBrand?: Maybe<Scalars['Boolean']>
    /** undefined Only available with roles ADMIN */
    createModel?: Maybe<ConfigurationModel>
    /** undefined Only available with roles ADMIN */
    updateModel?: Maybe<ConfigurationModel>
    /** undefined Only available with roles ADMIN */
    removeModel?: Maybe<Scalars['Boolean']>
    /** undefined Only available with roles ADMIN */
    createEdition?: Maybe<ConfigurationEdition>
    /** undefined Only available with roles ADMIN */
    updateEdition?: Maybe<ConfigurationEdition>
    /** undefined Only available with roles ADMIN */
    removeEdition?: Maybe<Scalars['Boolean']>
    /** undefined Only available with roles ADMIN */
    addOptionToEdition?: Maybe<EditionOption>
    /** undefined Only available with roles ADMIN */
    updateEditionOption?: Maybe<EditionOption>
    /** undefined Only available with roles ADMIN */
    copyEditionOptionsForEdition?: Maybe<Array<Maybe<EditionOption>>>
    /** undefined Only available with roles ADMIN */
    removeEditionOption?: Maybe<Scalars['Boolean']>
    /** undefined Only available with roles ADMIN */
    createOption?: Maybe<Option>
    /** undefined Only available with roles ADMIN */
    updateOption?: Maybe<Option>
    /** undefined Only available with roles ADMIN */
    removeOption?: Maybe<Scalars['Boolean']>
    /** undefined Only available with roles ADMIN */
    createResidualValueTable?: Maybe<ResidualValueTableResult>
    /** undefined Only available with roles ADMIN */
    copyResidualValueTable?: Maybe<ResidualValueTableResult>
    /** undefined Only available with roles ADMIN */
    updateResidualValueTable?: Maybe<ResidualValueTableResult>
    /** undefined Only available with roles ADMIN */
    removeResidualValueTable?: Maybe<Scalars['Boolean']>
    /** undefined Only available with roles ADMIN */
    upsertPricingConfigurationCalculation?: Maybe<ConfigurationCalculation>
    /** undefined Only available with roles ADMIN */
    duplicatePricingConfigurationCalculation?: Maybe<ConfigurationCalculation>
    /** undefined Only available with roles ADMIN */
    removeConfigurationCalculation?: Maybe<RemoveConfigurationCalculationResult>
    upsertContract?: Maybe<UpsertContractResult>
    importContractFromLeasewise?: Maybe<Scalars['String']>
    /** undefined Only available with roles ADMIN */
    generateEndContractProposition?: Maybe<Scalars['String']>
    /** undefined Only available with roles ADMIN */
    generateUpgradeProposition?: Maybe<Scalars['String']>
    /** undefined Only available with roles ADMIN */
    generateContractRecalculationProposition?: Maybe<Scalars['String']>
    /** undefined Only available with roles ADMIN */
    generateFSDProposition?: Maybe<Scalars['String']>
    /** undefined Only available with roles ADMIN */
    generatePremiumConnectivityProposition?: Maybe<Scalars['String']>
    /** undefined Only available with roles ADMIN */
    generateAccessoryProposition?: Maybe<Scalars['String']>
    /** undefined Only available with roles ADMIN */
    uploadContractAttachment: Array<ContractAttachment>
    /** undefined Only available with roles ADMIN */
    deleteContractAttachment?: Maybe<Scalars['Boolean']>
    createDeal: Deal
    /** undefined Only available when authenticated. */
    connectDeal: Deal
    updateSelectableDealOption: Deal
    updateBooleanDealOption: Deal
    /** undefined Only available with roles ADMIN */
    updateDealMargin: Deal
    /** undefined Only available when authenticated. */
    updateDealMileage: Deal
    /** undefined Only available with roles ADMIN */
    updateDealDuration: Deal
    /** undefined Only available with roles ADMIN */
    updateDealPrice: Deal
    /** undefined Only available with roles ADMIN */
    updateDealLessKm: Deal
    /** undefined Only available with roles ADMIN */
    updateDealMoreKm: Deal
    /** undefined Only available with roles ADMIN */
    updateDealPrivateLeaseLessKm: Deal
    /** undefined Only available with roles ADMIN */
    updateDealPrivateLeaseMoreKm: Deal
    /** undefined Only available when authenticated. */
    makeDealOffer: Deal
    /** undefined Only available with roles ADMIN */
    duplicateDeal?: Maybe<Deal>
    /** undefined Only available when authenticated. */
    acceptDealOffer: Deal
    /** undefined Only available with roles ADMIN */
    finalizeDeal: Deal
    /** undefined Only available when authenticated. */
    cancelDeal: Deal
    /** undefined Only available when authenticated. */
    addSigningpersonToDeal: Deal
    /** undefined Only available when authenticated. */
    removeSigningpersonFromDeal: Deal
    /** undefined Only available when authenticated. */
    signViaIdeal: Scalars['String']
    /** undefined Only available when authenticated. */
    createDealDocumentUploadToken: Scalars['String']
    /** undefined Only available with roles ADMIN */
    verifyDealDocument: Deal
    /** undefined Only available when authenticated. */
    updateDealDriver: Deal
    updateDealReferralCode: Deal
    /** undefined Only available when authenticated. */
    updateDealManufacturerReferralCode: Deal
    /** undefined Only available when authenticated. */
    updateDealManufacturerAccountEmailAddress: Deal
    /** undefined Only available when authenticated. */
    updateDealLessee: Deal
    /** undefined Only available with roles ADMIN */
    updateDealInternalOwner: Deal
    /** undefined Only available when authenticated. */
    updateDealContact: Deal
    /** undefined Only available when authenticated. */
    updateDealBilling: Deal
    /** undefined Only available with roles ADMIN */
    updateDealKcStatus: Deal
    /** undefined Only available with roles ADMIN */
    updateDealKvkStatus: Deal
    /** undefined Only available with roles ADMIN */
    updateDealOwner: Deal
    /** undefined Only available with roles ADMIN */
    updateDealRemarks: Deal
    /** undefined Only available with roles ADMIN */
    updateDealOptionsDescription: Deal
    /** undefined Only available with roles ADMIN */
    updateDealLocale: Deal
    /** undefined Only available when authenticated. */
    uploadDocument?: Maybe<Document>
    /** undefined Only available with roles ADMIN */
    renameDocument?: Maybe<Document>
    /** undefined Only available with roles ADMIN */
    deleteDocument?: Maybe<DeleteDocumentResult>
    /** undefined Only available with roles ADMIN */
    upsertEmailTemplate?: Maybe<EmailTemplate>
    /** undefined Only available with roles ADMIN */
    removeEmailTemplate?: Maybe<Scalars['Boolean']>
    /** undefined Only available with roles ADMIN */
    sendTestEmail?: Maybe<Scalars['Boolean']>
    /** undefined Only available when authenticated. */
    executeLicenseCheck?: Maybe<Result>
    /** undefined Only available with roles ADMIN */
    editCheckResult?: Maybe<Result>
    /** undefined Only available with roles ADMIN */
    dealToLeasewise?: Maybe<LeasewiseOfferStatus>
    /** undefined Only available with roles ADMIN */
    createAutodiskModel?: Maybe<AutodiskModel>
    /** undefined Only available with roles ADMIN */
    updateAutodiskModel?: Maybe<AutodiskModel>
    /** undefined Only available with roles ADMIN */
    deleteAutodiskModel?: Maybe<AutodiskDeleteResult>
    /** undefined Only available with roles ADMIN */
    createAutodiskEdition?: Maybe<AutodiskEdition>
    /** undefined Only available with roles ADMIN */
    updateAutodiskEdition?: Maybe<AutodiskEdition>
    /** undefined Only available with roles ADMIN */
    deleteAutodiskEdition?: Maybe<AutodiskDeleteResult>
    /** undefined Only available when authenticated. */
    signLegalDocumentAgreement?: Maybe<LegalDocumentAgreement>
    /** undefined Only available with roles ADMIN */
    createLegalDocumentContent?: Maybe<LegalDocumentContent>
    /** undefined Only available with roles ADMIN */
    updateLegalDocumentContent?: Maybe<LegalDocumentContent>
    /** undefined Only available with roles ADMIN */
    deleteLegalDocumentContent?: Maybe<Scalars['Boolean']>
    /** undefined Only available with roles ADMIN */
    publishLegalDocumentContent?: Maybe<Scalars['Boolean']>
    /** undefined Only available with roles ADMIN */
    archiveLegalDocumentContent?: Maybe<Scalars['Boolean']>
    /** undefined Only available with roles ADMIN */
    createLegalDocument?: Maybe<LegalDocument>
    /** undefined Only available with roles ADMIN */
    updateLegalDocument?: Maybe<LegalDocument>
    /** undefined Only available with roles ADMIN */
    archiveLegalDocument?: Maybe<Scalars['Boolean']>
    /** undefined Only available with roles TENANT_ADMIN */
    updateTenantSettings?: Maybe<TenantSettings>
    /** undefined Only available with roles ADMIN */
    createUserProfile?: Maybe<UserProfile>
    /** undefined Only available with roles ADMIN */
    updateUserProfile?: Maybe<UserProfile>
    /** undefined Only available when authenticated. */
    updateMyUserProfile?: Maybe<UserProfile>
    /** undefined Only available with roles ADMIN */
    deleteUserProfile?: Maybe<Scalars['Boolean']>
    /** undefined Only available with roles ADMIN */
    upsertWorkflow?: Maybe<Workflow>
    /** undefined Only available with roles ADMIN */
    removeWorkflow?: Maybe<Scalars['Boolean']>
}

export type MutationCreateLoginUrlArgs = {
    userId: Scalars['ID']
    path?: Maybe<Scalars['String']>
}

export type MutationExchangeForJsonWebTokenArgs = {
    loginTokenId: Scalars['ID']
    loginToken?: Maybe<Scalars['String']>
}

export type MutationRefreshLoginUrlArgs = {
    email: Scalars['String']
    path: Scalars['String']
}

export type MutationRequestLoginEmailArgs = {
    email: Scalars['String']
    path?: Maybe<Scalars['String']>
}

export type MutationCreateJsonWebTokenArgs = {
    userId: Scalars['ID']
}

export type MutationSignupUserArgs = {
    emailAddress: Scalars['String']
}

export type MutationCreateUserArgs = {
    emailAddress: Scalars['String']
}

export type MutationAddUserRoleArgs = {
    id: Scalars['ID']
    role?: Maybe<Role>
}

export type MutationSetUserRolesArgs = {
    id: Scalars['ID']
    role?: Maybe<Array<Maybe<Role>>>
}

export type MutationSetUserTenantsArgs = {
    userId: Scalars['ID']
    tenants: Array<Scalars['String']>
}

export type MutationRemoveUserRoleArgs = {
    id: Scalars['ID']
    role?: Maybe<Role>
}

export type MutationDeleteUserArgs = {
    id: Scalars['ID']
}

export type MutationUpsertCarArgs = {
    id?: Maybe<Scalars['ID']>
    input: CarInput
}

export type MutationRemoveCarArgs = {
    id: Scalars['ID']
}

export type MutationImportCarFromLeasewiseArgs = {
    VIN: Scalars['String']
}

export type MutationPublishToCarShopArgs = {
    carId: Scalars['ID']
    input: CarShopPublicationInput
}

export type MutationUnpublishRemarketingPublicationArgs = {
    id: Scalars['ID']
}

export type MutationCreateBrandArgs = {
    input: ConfigurationBrandInput
}

export type MutationUpdateBrandArgs = {
    id: Scalars['ID']
    input?: Maybe<ConfigurationBrandInput>
}

export type MutationRemoveBrandArgs = {
    id: Scalars['ID']
}

export type MutationCreateModelArgs = {
    input: ConfigurationModelInput
}

export type MutationUpdateModelArgs = {
    id: Scalars['ID']
    input: ConfigurationModelInput
}

export type MutationRemoveModelArgs = {
    id: Scalars['ID']
}

export type MutationCreateEditionArgs = {
    input: ConfigurationEditionInput
}

export type MutationUpdateEditionArgs = {
    id: Scalars['ID']
    input: ConfigurationEditionInput
}

export type MutationRemoveEditionArgs = {
    id: Scalars['ID']
}

export type MutationAddOptionToEditionArgs = {
    input: NewConfigurationEditionOptionInput
}

export type MutationUpdateEditionOptionArgs = {
    id: Scalars['ID']
    input: ConfigurationEditionOptionInput
}

export type MutationCopyEditionOptionsForEditionArgs = {
    fromEditionId: Scalars['String']
    toEditionId: Scalars['String']
}

export type MutationRemoveEditionOptionArgs = {
    id: Scalars['ID']
}

export type MutationCreateOptionArgs = {
    input: ConfigurationOptionInput
}

export type MutationUpdateOptionArgs = {
    id: Scalars['ID']
    input: ConfigurationOptionInput
}

export type MutationRemoveOptionArgs = {
    id: Scalars['ID']
}

export type MutationCreateResidualValueTableArgs = {
    input: ResidualValueTableInput
}

export type MutationCopyResidualValueTableArgs = {
    input: CopyResidualValueInput
}

export type MutationUpdateResidualValueTableArgs = {
    id: Scalars['ID']
    input: ResidualValueTableInput
}

export type MutationRemoveResidualValueTableArgs = {
    id: Scalars['ID']
}

export type MutationUpsertPricingConfigurationCalculationArgs = {
    id?: Maybe<Scalars['ID']>
    input: PricingConfigurationCalculationInput
}

export type MutationDuplicatePricingConfigurationCalculationArgs = {
    id: Scalars['ID']
    name: Scalars['String']
    tenant?: Maybe<Scalars['String']>
}

export type MutationRemoveConfigurationCalculationArgs = {
    id: Scalars['ID']
}

export type MutationUpsertContractArgs = {
    id: Scalars['ID']
    input: ContractInput
}

export type MutationImportContractFromLeasewiseArgs = {
    VIN: Scalars['String']
}

export type MutationGenerateEndContractPropositionArgs = {
    id: Scalars['ID']
    signingPersonEmailAddress: Scalars['String']
    propositionDate: Scalars['Date']
    language: Scalars['String']
}

export type MutationGenerateUpgradePropositionArgs = {
    id: Scalars['ID']
    signingPersonEmailAddress: Scalars['String']
    propositionDate: Scalars['Date']
}

export type MutationGenerateContractRecalculationPropositionArgs = {
    id: Scalars['ID']
    signingPersonEmailAddress: Scalars['String']
    newTotalMileage: Scalars['Int']
}

export type MutationGenerateFsdPropositionArgs = {
    id: Scalars['ID']
    signingPersonEmailAddress: Scalars['String']
    type: FsdPropositionType
    amount: Scalars['Float']
}

export type MutationGeneratePremiumConnectivityPropositionArgs = {
    id: Scalars['ID']
    signingPersonEmailAddress: Scalars['String']
}

export type MutationGenerateAccessoryPropositionArgs = {
    id: Scalars['ID']
    signingPersonEmailAddress: Scalars['String']
    accessory: Scalars['String']
}

export type MutationUploadContractAttachmentArgs = {
    contractId: Scalars['ID']
    type: ContractAttachmentType
    encodedFile: Scalars['Base64']
    fileName: Scalars['String']
}

export type MutationDeleteContractAttachmentArgs = {
    attachmentId: Scalars['ID']
}

export type MutationCreateDealArgs = {
    input: DealInput
}

export type MutationConnectDealArgs = {
    id: Scalars['ID']
}

export type MutationUpdateSelectableDealOptionArgs = {
    id: Scalars['ID']
    dealOptionId: Scalars['ID']
    valueId: Scalars['ID']
    showAllEditions?: Maybe<Scalars['Boolean']>
}

export type MutationUpdateBooleanDealOptionArgs = {
    id: Scalars['ID']
    dealOptionId: Scalars['ID']
    value: Scalars['Boolean']
}

export type MutationUpdateDealMarginArgs = {
    id: Scalars['ID']
    margin: Scalars['Float']
}

export type MutationUpdateDealMileageArgs = {
    id: Scalars['ID']
    mileage: Scalars['Int']
}

export type MutationUpdateDealDurationArgs = {
    id: Scalars['ID']
    duration: Scalars['Int']
}

export type MutationUpdateDealPriceArgs = {
    id: Scalars['ID']
    priceExVAT: Scalars['Float']
}

export type MutationUpdateDealLessKmArgs = {
    id: Scalars['ID']
    lessKmPriceExVAT?: Maybe<Scalars['Float']>
}

export type MutationUpdateDealMoreKmArgs = {
    id: Scalars['ID']
    moreKmPriceExVAT?: Maybe<Scalars['Float']>
}

export type MutationUpdateDealPrivateLeaseLessKmArgs = {
    id: Scalars['ID']
    privateLeaseLessKmIncVAT?: Maybe<Scalars['Float']>
}

export type MutationUpdateDealPrivateLeaseMoreKmArgs = {
    id: Scalars['ID']
    privateLeaseMoreKmIncVAT?: Maybe<Scalars['Float']>
}

export type MutationMakeDealOfferArgs = {
    id: Scalars['ID']
}

export type MutationDuplicateDealArgs = {
    id: Scalars['ID']
}

export type MutationAcceptDealOfferArgs = {
    id: Scalars['ID']
}

export type MutationFinalizeDealArgs = {
    id: Scalars['ID']
    comment?: Maybe<Scalars['String']>
}

export type MutationCancelDealArgs = {
    id: Scalars['ID']
    comment?: Maybe<Scalars['String']>
}

export type MutationAddSigningpersonToDealArgs = {
    id: Scalars['ID']
    email: Scalars['EmailAddress']
}

export type MutationRemoveSigningpersonFromDealArgs = {
    id: Scalars['ID']
    email: Scalars['EmailAddress']
}

export type MutationSignViaIdealArgs = {
    id: Scalars['ID']
    bankId: Scalars['String']
    callbackPath: Scalars['String']
}

export type MutationCreateDealDocumentUploadTokenArgs = {
    id: Scalars['ID']
}

export type MutationVerifyDealDocumentArgs = {
    documentSignatureId: Scalars['ID']
    isVerified: Scalars['Boolean']
}

export type MutationUpdateDealDriverArgs = {
    id: Scalars['ID']
    email?: Maybe<Scalars['String']>
}

export type MutationUpdateDealReferralCodeArgs = {
    id: Scalars['ID']
    code: Scalars['String']
}

export type MutationUpdateDealManufacturerReferralCodeArgs = {
    id: Scalars['ID']
    code: Scalars['String']
}

export type MutationUpdateDealManufacturerAccountEmailAddressArgs = {
    id: Scalars['ID']
    email: Scalars['EmailAddress']
}

export type MutationUpdateDealLesseeArgs = {
    id: Scalars['ID']
    input?: Maybe<CompanyInput>
}

export type MutationUpdateDealInternalOwnerArgs = {
    id: Scalars['ID']
    userId?: Maybe<Scalars['String']>
}

export type MutationUpdateDealContactArgs = {
    id: Scalars['ID']
    input?: Maybe<DealContactInput>
}

export type MutationUpdateDealBillingArgs = {
    id: Scalars['ID']
    input?: Maybe<DealBillingInput>
}

export type MutationUpdateDealKcStatusArgs = {
    id: Scalars['ID']
    status: InternalStatus
    message?: Maybe<Scalars['String']>
}

export type MutationUpdateDealKvkStatusArgs = {
    id: Scalars['ID']
    status: InternalStatus
    message?: Maybe<Scalars['String']>
}

export type MutationUpdateDealOwnerArgs = {
    id: Scalars['ID']
    userId: Scalars['String']
}

export type MutationUpdateDealRemarksArgs = {
    id: Scalars['ID']
    remarks: Scalars['String']
}

export type MutationUpdateDealOptionsDescriptionArgs = {
    id: Scalars['ID']
    optionsDescription: Scalars['String']
}

export type MutationUpdateDealLocaleArgs = {
    id: Scalars['ID']
    locale: DealLocale
}

export type MutationUploadDocumentArgs = {
    input: DocumentInput
}

export type MutationRenameDocumentArgs = {
    id: Scalars['ID']
    input: RenameDocumentInput
}

export type MutationDeleteDocumentArgs = {
    id: Scalars['ID']
}

export type MutationUpsertEmailTemplateArgs = {
    id?: Maybe<Scalars['ID']>
    input: EmailTemplateInput
}

export type MutationRemoveEmailTemplateArgs = {
    id: Scalars['ID']
}

export type MutationSendTestEmailArgs = {
    id: Scalars['ID']
    recipientEmailAddress: Scalars['String']
}

export type MutationEditCheckResultArgs = {
    userId: Scalars['ID']
}

export type MutationDealToLeasewiseArgs = {
    dealId: Scalars['ID']
}

export type MutationCreateAutodiskModelArgs = {
    input?: Maybe<AutodiskModelInput>
}

export type MutationUpdateAutodiskModelArgs = {
    id: Scalars['ID']
    input?: Maybe<AutodiskModelInput>
}

export type MutationDeleteAutodiskModelArgs = {
    id: Scalars['ID']
}

export type MutationCreateAutodiskEditionArgs = {
    input?: Maybe<AutodiskEditionInput>
}

export type MutationUpdateAutodiskEditionArgs = {
    id: Scalars['ID']
    input?: Maybe<AutodiskEditionInput>
}

export type MutationDeleteAutodiskEditionArgs = {
    id: Scalars['ID']
}

export type MutationSignLegalDocumentAgreementArgs = {
    documentId?: Maybe<Scalars['String']>
    slug?: Maybe<Scalars['String']>
    name?: Maybe<Scalars['String']>
    locale?: Maybe<Scalars['String']>
    variables?: Maybe<Array<Maybe<LegalDocumentAgreementVariableInput>>>
    contentId?: Maybe<Scalars['String']>
    hash: Scalars['String']
}

export type MutationCreateLegalDocumentContentArgs = {
    legalDocumentId: Scalars['ID']
    title: Scalars['String']
    body: Scalars['String']
    agreement: Scalars['String']
    summary: Scalars['String']
}

export type MutationUpdateLegalDocumentContentArgs = {
    id: Scalars['ID']
    title: Scalars['String']
    body: Scalars['String']
    agreement: Scalars['String']
    summary: Scalars['String']
}

export type MutationDeleteLegalDocumentContentArgs = {
    id: Scalars['ID']
}

export type MutationPublishLegalDocumentContentArgs = {
    id: Scalars['ID']
}

export type MutationArchiveLegalDocumentContentArgs = {
    id: Scalars['ID']
}

export type MutationCreateLegalDocumentArgs = {
    name: Scalars['String']
    slug: Scalars['String']
    locale: Scalars['String']
}

export type MutationUpdateLegalDocumentArgs = {
    id: Scalars['ID']
    name: Scalars['String']
    slug: Scalars['String']
    locale: Scalars['String']
}

export type MutationArchiveLegalDocumentArgs = {
    id: Scalars['ID']
}

export type MutationUpdateTenantSettingsArgs = {
    id: Scalars['ID']
    input: TenantSettingsInput
}

export type MutationCreateUserProfileArgs = {
    firstName?: Maybe<Scalars['String']>
    legalFirstNames?: Maybe<Scalars['String']>
    lastName?: Maybe<Scalars['String']>
    lastNamePrefix?: Maybe<Scalars['String']>
    telephoneNumber?: Maybe<Scalars['String']>
    address?: Maybe<UserAddressInput>
    userId?: Maybe<Scalars['String']>
    emailAddress?: Maybe<Scalars['String']>
}

export type MutationUpdateUserProfileArgs = {
    id: Scalars['ID']
    firstName?: Maybe<Scalars['String']>
    legalFirstNames?: Maybe<Scalars['String']>
    lastName?: Maybe<Scalars['String']>
    lastNamePrefix?: Maybe<Scalars['String']>
    telephoneNumber?: Maybe<Scalars['String']>
    address?: Maybe<UserAddressInput>
    userId?: Maybe<Scalars['String']>
    emailAddress?: Maybe<Scalars['String']>
}

export type MutationUpdateMyUserProfileArgs = {
    firstName?: Maybe<Scalars['String']>
    legalFirstNames?: Maybe<Scalars['String']>
    lastName?: Maybe<Scalars['String']>
    lastNamePrefix?: Maybe<Scalars['String']>
    telephoneNumber?: Maybe<Scalars['String']>
    address?: Maybe<UserAddressInput>
    emailAddress?: Maybe<Scalars['String']>
}

export type MutationDeleteUserProfileArgs = {
    id?: Maybe<Scalars['ID']>
    userId?: Maybe<Scalars['String']>
}

export type MutationUpsertWorkflowArgs = {
    id?: Maybe<Scalars['ID']>
    input: WorkflowInput
}

export type MutationRemoveWorkflowArgs = {
    id: Scalars['ID']
}

export type NewConfigurationEditionOptionInput = {
    optionId: Scalars['String']
    editionId: Scalars['String']
    fiscalValue?: Maybe<Scalars['Int']>
    default?: Maybe<Scalars['Boolean']>
    type?: Maybe<ConfigurationEditionOptionType>
    price?: Maybe<Scalars['Float']>
}

export type OnfidoSdkToken = {
    __typename?: 'OnfidoSDKToken'
    token: Scalars['String']
}

export type Option = {
    __typename?: 'Option'
    id: Scalars['ID']
    type?: Maybe<Scalars['String']>
    name?: Maybe<Scalars['String']>
    manufacturerCode?: Maybe<Scalars['String']>
    displayOrder: Scalars['Int']
}

export type OptionPrice = {
    __typename?: 'OptionPrice'
    option?: Maybe<Scalars['String']>
    price?: Maybe<Scalars['Int']>
    default?: Maybe<Scalars['Boolean']>
}

export type OrderBy = {
    field?: Maybe<Scalars['String']>
    asc?: Maybe<Scalars['Boolean']>
}

export type PaginatedResult = {
    totalResults?: Maybe<Scalars['Int']>
}

export type Pagination = {
    offset?: Maybe<Scalars['Int']>
    limit?: Maybe<Scalars['Int']>
}

export enum PaymentStatus {
    NotStarted = 'NOT_STARTED',
    Pending = 'PENDING',
    Accepted = 'ACCEPTED',
    Rejected = 'REJECTED',
}

export type PaymentSummary = {
    __typename?: 'PaymentSummary'
    id: Scalars['ID']
    createdAt: Scalars['Date']
    updatedAt: Scalars['Date']
    expiredAmount?: Maybe<Scalars['Float']>
    paymentScore?: Maybe<Scalars['Float']>
    invoicesPaidTooLate?: Maybe<Scalars['Int']>
}

export type PdfMetadata = {
    __typename?: 'PdfMetadata'
    sizeInBytes?: Maybe<Scalars['Int']>
    pages?: Maybe<Scalars['Int']>
    pdfVersion?: Maybe<Scalars['String']>
}

export type PremiumConnectivityProposition = {
    __typename?: 'PremiumConnectivityProposition'
    id: Scalars['ID']
    oldPricePerMonthExVAT: Scalars['Float']
    newPricePerMonthExVAT: Scalars['Float']
    priceIncreaseExVAT: Scalars['Float']
    oldPricePerMonthIncVAT: Scalars['Float']
    newPricePerMonthIncVAT: Scalars['Float']
    priceIncreaseIncVAT: Scalars['Float']
}

export type Pricing = {
    __typename?: 'Pricing'
    id: Scalars['ID']
    pricePerMonthExVAT?: Maybe<Scalars['Float']>
    pricePerMonthIncVAT?: Maybe<Scalars['Float']>
    incVAT?: Maybe<Scalars['Boolean']>
    fiscalValue?: Maybe<Scalars['Float']>
    /** undefined Only available with roles ADMIN */
    margin?: Maybe<Scalars['Float']>
    /** undefined Only available with roles ADMIN */
    components?: Maybe<Array<Maybe<PricingCalculationComponent>>>
    lessKmPriceExVAT: Scalars['Float']
    moreKmPriceExVAT: Scalars['Float']
    privateLeaseLessKmPriceIncVAT: Scalars['Float']
    privateLeaseMoreKmPriceIncVAT: Scalars['Float']
}

export type PricingCalculationComponent =
    | PricingCalculationComponentMargin
    | PricingCalculationComponentInterest
    | PricingCalculationComponentInsurance
    | PricingCalculationComponentDepreciation
    | PricingCalculationComponentMaintenance
    | PricingCalculationComponentReplacementTransport
    | PricingCalculationComponentCustomMonthlyLeasePriceAddOn
    | PricingCalculationComponentCustomResidualValue
    | PricingCalculationComponentTire
    | PricingCalculationComponentAfterDelivery
    | PricingCalculationComponentLeaseEditionOption
    | PricingCalculationComponentDownpayment
    | PricingCalculationReferralDiscount

export type PricingCalculationComponentAfterDelivery = {
    __typename?: 'PricingCalculationComponentAfterDelivery'
    amountExVAT: Scalars['Float']
    component?: Maybe<PricingConfigurationComponentAfterDelivery>
}

export type PricingCalculationComponentCustomMonthlyLeasePriceAddOn = {
    __typename?: 'PricingCalculationComponentCustomMonthlyLeasePriceAddOn'
    amountExVAT: Scalars['Float']
    component?: Maybe<PricingConfigurationComponentCustomMonthlyLeasePriceAddOn>
}

export type PricingCalculationComponentCustomResidualValue = {
    __typename?: 'PricingCalculationComponentCustomResidualValue'
    amountExVAT: Scalars['Float']
    component?: Maybe<PricingConfigurationComponentCustomResidualValue>
}

export type PricingCalculationComponentDepreciation = {
    __typename?: 'PricingCalculationComponentDepreciation'
    amountExVAT: Scalars['Float']
    component?: Maybe<PricingConfigurationComponentDepreciationPercentage>
}

export type PricingCalculationComponentDownpayment = {
    __typename?: 'PricingCalculationComponentDownpayment'
    discountExVAT: Scalars['Float']
    component?: Maybe<PricingConfigurationComponentDownpayment>
}

export type PricingCalculationComponentInsurance = {
    __typename?: 'PricingCalculationComponentInsurance'
    amountExVAT: Scalars['Float']
    component?: Maybe<PricingConfigurationComponentInsurance>
}

export type PricingCalculationComponentInterest = {
    __typename?: 'PricingCalculationComponentInterest'
    amountExVAT: Scalars['Float']
    component?: Maybe<PricingConfigurationComponentInterest>
}

export type PricingCalculationComponentLeaseEditionOption = {
    __typename?: 'PricingCalculationComponentLeaseEditionOption'
    amountExVAT: Scalars['Float']
    component?: Maybe<PricingConfigurationComponentLeaseEditionOption>
}

export type PricingCalculationComponentMaintenance = {
    __typename?: 'PricingCalculationComponentMaintenance'
    amountExVAT: Scalars['Float']
    component?: Maybe<PricingConfigurationComponentMaintenance>
}

export type PricingCalculationComponentMargin = {
    __typename?: 'PricingCalculationComponentMargin'
    amountExVAT: Scalars['Float']
    component?: Maybe<PricingConfigurationComponentMargin>
}

export type PricingCalculationComponentReplacementTransport = {
    __typename?: 'PricingCalculationComponentReplacementTransport'
    amountExVAT: Scalars['Float']
    component?: Maybe<PricingConfigurationComponentReplacementTransport>
}

export type PricingCalculationComponentTire = {
    __typename?: 'PricingCalculationComponentTire'
    amountExVAT: Scalars['Float']
    component?: Maybe<PricingConfigurationComponentTire>
}

export enum PricingCalculationComponentType {
    Margin = 'MARGIN',
    ExactMargin = 'EXACT_MARGIN',
    InterestRate = 'INTEREST_RATE',
    Insurance = 'INSURANCE',
    Maintenance = 'MAINTENANCE',
    ReplacementTransportation = 'REPLACEMENT_TRANSPORTATION',
    CustomMonthlyAddOn = 'CUSTOM_MONTHLY_ADD_ON',
    CustomResidualValue = 'CUSTOM_RESIDUAL_VALUE',
    ResidualValueTable = 'RESIDUAL_VALUE_TABLE',
    AfterDeliveryOption = 'AFTER_DELIVERY_OPTION',
    LeaseEditionOption = 'LEASE_EDITION_OPTION',
    TireOption = 'TIRE_OPTION',
    Downpayment = 'DOWNPAYMENT',
    ReferralDiscount = 'REFERRAL_DISCOUNT',
}

export type PricingCalculationReferralDiscount = {
    __typename?: 'PricingCalculationReferralDiscount'
    discountExVAT: Scalars['Float']
    component?: Maybe<PricingConfigurationComponentReferralDiscount>
}

export type PricingCondition = {
    __typename?: 'PricingCondition'
    AND?: Maybe<Array<Maybe<PricingCondition>>>
    OR?: Maybe<Array<Maybe<PricingCondition>>>
    condition?: Maybe<PricingConditionType>
}

export type PricingConditionBlock = {
    __typename?: 'PricingConditionBlock'
    conditions?: Maybe<PricingCondition>
    components: Array<PricingConfigurationComponent>
}

export type PricingConditionBlockInput = {
    conditions?: Maybe<PricingConditionInput>
    components: Array<PricingConfigurationComponentInput>
}

export type PricingConditionCarOption = {
    __typename?: 'PricingConditionCarOption'
    property: PricingConditionProperty
    operator: PricingConditionOperator
    optionId: Scalars['String']
}

export type PricingConditionFiscalValue = {
    __typename?: 'PricingConditionFiscalValue'
    property: PricingConditionProperty
    operator: PricingConditionOperator
    fiscalValue: Scalars['Float']
}

export type PricingConditionInput = {
    AND?: Maybe<Array<Maybe<PricingConditionInput>>>
    OR?: Maybe<Array<Maybe<PricingConditionInput>>>
    leasingTypeCondition?: Maybe<PricingConditionInputLeasingType>
    fiscalValueCondition?: Maybe<PricingConditionInputFiscalValue>
    carOptionsCondition?: Maybe<PricingConditionInputCarOptions>
}

export type PricingConditionInputCarOptions = {
    property: PricingConditionProperty
    operator: PricingConditionOperator
    optionId: Scalars['String']
}

export type PricingConditionInputFiscalValue = {
    property: PricingConditionProperty
    operator: PricingConditionOperator
    fiscalValue: Scalars['Float']
}

export type PricingConditionInputLeasingType = {
    property: PricingConditionProperty
    operator: PricingConditionOperator
    leasingType: LeasingType
}

export type PricingConditionLeasingType = {
    __typename?: 'PricingConditionLeasingType'
    property: PricingConditionProperty
    operator: PricingConditionOperator
    leasingType: LeasingType
}

export enum PricingConditionOperator {
    IsEqualTo = 'IS_EQUAL_TO',
    IsLessThan = 'IS_LESS_THAN',
    IsGreaterThan = 'IS_GREATER_THAN',
    IsNotEqualTo = 'IS_NOT_EQUAL_TO',
    Includes = 'INCLUDES',
    DoesNotInclude = 'DOES_NOT_INCLUDE',
}

export enum PricingConditionProperty {
    LeasingType = 'LEASING_TYPE',
    FiscalValue = 'FISCAL_VALUE',
    CarOptions = 'CAR_OPTIONS',
}

export type PricingConditionType = PricingConditionLeasingType | PricingConditionFiscalValue | PricingConditionCarOption

export type PricingConfigurationCalculationFilter = {
    AND?: Maybe<Array<Maybe<PricingConfigurationCalculationFilter>>>
    OR?: Maybe<Array<Maybe<PricingConfigurationCalculationFilter>>>
}

export type PricingConfigurationCalculationInput = {
    name: Scalars['String']
    description?: Maybe<Scalars['String']>
    components: Array<PricingConfigurationComponentInput>
}

export type PricingConfigurationComponent =
    | PricingConfigurationComponentMargin
    | PricingConfigurationComponentInterest
    | PricingConfigurationComponentInsurance
    | PricingConfigurationComponentDepreciation
    | PricingConfigurationComponentMaintenance
    | PricingConfigurationComponentReplacementTransport
    | PricingConfigurationComponentCustomMonthlyLeasePriceAddOn
    | PricingConfigurationComponentCustomResidualValue
    | PricingConfigurationComponentConditional

export type PricingConfigurationComponentAfterDelivery = {
    __typename?: 'PricingConfigurationComponentAfterDelivery'
    type: PricingCalculationComponentType
}

export type PricingConfigurationComponentConditional = {
    __typename?: 'PricingConfigurationComponentConditional'
    type?: Maybe<PricingConfigurationComponentType>
    conditionBlocks: Array<PricingConditionBlock>
    componentsDefault: Array<PricingConfigurationComponent>
}

export type PricingConfigurationComponentConditionalInput = {
    conditionBlocks?: Maybe<Array<Maybe<PricingConditionBlockInput>>>
    componentsDefault: Array<PricingConfigurationComponentInput>
}

export type PricingConfigurationComponentCustomMonthlyLeasePriceAddOn = {
    __typename?: 'PricingConfigurationComponentCustomMonthlyLeasePriceAddOn'
    type?: Maybe<PricingConfigurationComponentType>
    name: Scalars['String']
    description?: Maybe<Scalars['String']>
    monthlyAddOnAmountExVAT: Scalars['Float']
}

export type PricingConfigurationComponentCustomMonthlyLeasePriceAddOnInput = {
    name: Scalars['String']
    description?: Maybe<Scalars['String']>
    monthlyAddOnAmountExVAT: Scalars['Float']
}

export type PricingConfigurationComponentCustomResidualValue = {
    __typename?: 'PricingConfigurationComponentCustomResidualValue'
    type?: Maybe<PricingConfigurationComponentType>
    name: Scalars['String']
    description?: Maybe<Scalars['String']>
    fiscalValue: Scalars['Float']
    residualValuePercentage: Scalars['Float']
    partOfInvestment: Scalars['Boolean']
}

export type PricingConfigurationComponentCustomResidualValueInput = {
    name: Scalars['String']
    description?: Maybe<Scalars['String']>
    partOfInvestment: Scalars['Boolean']
    fiscalValue: Scalars['Float']
    residualValuePercentage: Scalars['Float']
}

export type PricingConfigurationComponentDepreciation = {
    __typename?: 'PricingConfigurationComponentDepreciation'
    type?: Maybe<PricingConfigurationComponentType>
    residualValueTable?: Maybe<ResidualValueTable>
}

export type PricingConfigurationComponentDepreciationPercentage = {
    __typename?: 'PricingConfigurationComponentDepreciationPercentage'
    type?: Maybe<PricingConfigurationComponentType>
    residualValuePercentage: Scalars['Float']
    currentValueExVAT: Scalars['Float']
    residualValue: Scalars['Float']
    residualValueTableId: Scalars['String']
}

export type PricingConfigurationComponentDownpayment = {
    __typename?: 'PricingConfigurationComponentDownpayment'
    downpaymentAmount: Scalars['Float']
    type: PricingCalculationComponentType
}

export type PricingConfigurationComponentHull = {
    __typename?: 'PricingConfigurationComponentHull'
    startingAtFiscalValue?: Maybe<Scalars['Float']>
    endingAtFiscalValue?: Maybe<Scalars['Float']>
    amountExVATPerStep: Scalars['Float']
    perStepInFiscalValue: Scalars['Float']
}

export type PricingConfigurationComponentHullInput = {
    startingAtFiscalValue: Scalars['Float']
    endingAtFiscalValue: Scalars['Float']
    amountExVATPerStep: Scalars['Float']
    perStepInFiscalValue: Scalars['Float']
}

export type PricingConfigurationComponentInput = {
    type: PricingConfigurationComponentType
    margin?: Maybe<PricingConfigurationComponentMarginInput>
    interestRate?: Maybe<PricingConfigurationComponentInterestInput>
    insuranceCalculation?: Maybe<PricingConfigurationComponentInsuranceInput>
    maintenanceCalculation?: Maybe<PricingConfigurationComponentMaintenanceCalculationInput>
    replacementTransportCalculation?: Maybe<PricingConfigurationComponentReplacementTransportInput>
    customMonthlyAddOnCalculation?: Maybe<PricingConfigurationComponentCustomMonthlyLeasePriceAddOnInput>
    customResidualValueCalculation?: Maybe<PricingConfigurationComponentCustomResidualValueInput>
    residualValueTable?: Maybe<PricingConfigurationComponentResidualValueTableInput>
    conditional?: Maybe<PricingConfigurationComponentConditionalInput>
}

export type PricingConfigurationComponentInsurance = {
    __typename?: 'PricingConfigurationComponentInsurance'
    type?: Maybe<PricingConfigurationComponentType>
    liability: Scalars['Float']
    hull: PricingConfigurationComponentHull
    insurancePremiumTaxPercentage: Scalars['Float']
    insuranceMarkupPercentage: Scalars['Float']
    deductible?: Maybe<PricingConfigurationComponentInsuranceDeductible>
}

export type PricingConfigurationComponentInsuranceDeductible = {
    __typename?: 'PricingConfigurationComponentInsuranceDeductible'
    higher?: Maybe<Scalars['Float']>
    regular?: Maybe<Scalars['Float']>
    lower?: Maybe<Scalars['Float']>
}

export type PricingConfigurationComponentInsuranceInput = {
    liability: Scalars['Float']
    hull: PricingConfigurationComponentHullInput
    insurancePremiumTaxPercentage: Scalars['Float']
    insuranceMarkupPercentage: Scalars['Float']
    deductible: PricingConfigurationComponentInsuranceInputDeductible
}

export type PricingConfigurationComponentInsuranceInputDeductible = {
    higher: Scalars['Float']
    regular: Scalars['Float']
    lower: Scalars['Float']
}

export type PricingConfigurationComponentInterest = {
    __typename?: 'PricingConfigurationComponentInterest'
    type?: Maybe<PricingConfigurationComponentType>
    investmentExVAT: Scalars['Float']
    percentage: Scalars['Float']
}

export type PricingConfigurationComponentInterestInput = {
    percentage: Scalars['Float']
}

export type PricingConfigurationComponentLeaseEditionOption = {
    __typename?: 'PricingConfigurationComponentLeaseEditionOption'
    type: PricingCalculationComponentType
}

export type PricingConfigurationComponentMaintenance = {
    __typename?: 'PricingConfigurationComponentMaintenance'
    type?: Maybe<PricingConfigurationComponentType>
    amountExVATPerDistanceUnit: Scalars['Float']
}

export type PricingConfigurationComponentMaintenanceCalculationInput = {
    amountExVATPerDistanceUnit: Scalars['Float']
}

export type PricingConfigurationComponentMargin = {
    __typename?: 'PricingConfigurationComponentMargin'
    type?: Maybe<PricingConfigurationComponentType>
    percentage: Scalars['Float']
}

export type PricingConfigurationComponentMarginInput = {
    percentage: Scalars['Float']
}

export type PricingConfigurationComponentReferralDiscount = {
    __typename?: 'PricingConfigurationComponentReferralDiscount'
    type: PricingCalculationComponentType
    referralProgram: Scalars['String']
    referralCode: Scalars['String']
}

export type PricingConfigurationComponentReplacementTransport = {
    __typename?: 'PricingConfigurationComponentReplacementTransport'
    type?: Maybe<PricingConfigurationComponentType>
    amountExVATUntilCutOff: Scalars['Float']
    cutOffMileage: Scalars['Int']
    perMileageStepAboveCutOff: Scalars['Int']
    amountExVATPerStepAboveCutOff: Scalars['Float']
}

export type PricingConfigurationComponentReplacementTransportInput = {
    amountExVATUntilCutOff: Scalars['Float']
    cutOffMileage: Scalars['Int']
    perMileageStepAboveCutOff: Scalars['Int']
    amountExVATPerStepAboveCutOff: Scalars['Float']
}

export type PricingConfigurationComponentResidualValueTableInput = {
    residualValueTableId: Scalars['String']
}

export type PricingConfigurationComponentTire = {
    __typename?: 'PricingConfigurationComponentTire'
    type: PricingCalculationComponentType
    tirePricePerDistanceUnitExVAT: Scalars['Float']
}

export enum PricingConfigurationComponentType {
    Margin = 'MARGIN',
    InterestRate = 'INTEREST_RATE',
    Insurance = 'INSURANCE',
    Maintenance = 'MAINTENANCE',
    ReplacementTransportation = 'REPLACEMENT_TRANSPORTATION',
    CustomMonthlyAddOn = 'CUSTOM_MONTHLY_ADD_ON',
    CustomResidualValue = 'CUSTOM_RESIDUAL_VALUE',
    ResidualValueTable = 'RESIDUAL_VALUE_TABLE',
    Conditional = 'CONDITIONAL',
}

export type PricingPreview = {
    __typename?: 'PricingPreview'
    leasingPriceExVAT: Scalars['Float']
    leasingPriceIncVAT: Scalars['Float']
    fiscalValue: Scalars['Float']
    components?: Maybe<Array<Maybe<PricingCalculationComponent>>>
}

export type PricingPreviewInput = {
    editionId: Scalars['ID']
    mileage: Scalars['Int']
    duration: Scalars['Int']
    leasingType: LeasingType
    components: Array<PricingConfigurationComponentInput>
}

export type Proposition = {
    __typename?: 'Proposition'
    id: Scalars['ID']
    createdAt?: Maybe<Scalars['Date']>
    updatedAt?: Maybe<Scalars['Date']>
    type: PropositionType
    state: PropositionState
    pdfUrl?: Maybe<Scalars['String']>
}

export enum PropositionPaymentMethod {
    Invoice = 'INVOICE',
    LeaseIncrease = 'LEASE_INCREASE',
}

export enum PropositionState {
    Created = 'created',
    Draft = 'draft',
    Pending = 'pending',
    Completed = 'completed',
    Expired = 'expired',
    Declined = 'declined',
}

export enum PropositionType {
    EndContractProposition = 'EndContractProposition',
    UpgradeProposition = 'UpgradeProposition',
    ContractRecalculation = 'ContractRecalculation',
    FsdProposition = 'FSDProposition',
    AccessoryProposition = 'AccessoryProposition',
    PremiumConnectivityProposition = 'PremiumConnectivityProposition',
}

export type PublicationSuccessfullyUnpublished = {
    __typename?: 'PublicationSuccessfullyUnpublished'
    publicationId: Scalars['String']
}

export type Query = {
    __typename?: 'Query'
    LookupAddress?: Maybe<LookupAddress>
    /** undefined Only available with roles ADMIN */
    isRootToken?: Maybe<Scalars['Boolean']>
    /** undefined Only available when authenticated. */
    getCurrentUser?: Maybe<User>
    /** undefined Only available when authenticated. */
    myUser?: Maybe<User>
    /** undefined Only available with roles ADMIN */
    allUsers?: Maybe<Array<Maybe<User>>>
    /** undefined Only available with roles ADMIN */
    User?: Maybe<User>
    validateSignupUser?: Maybe<Scalars['Boolean']>
    /** undefined Only available with roles ADMIN */
    getTenants?: Maybe<Array<Maybe<Tenant>>>
    /** undefined Only available with roles ADMIN */
    getUsersByRole?: Maybe<Array<Maybe<User>>>
    /** undefined Only available with roles ADMIN */
    Car: CarResult
    /** undefined Only available with roles ADMIN */
    CarCollection: CarCollection
    /** undefined Only available with roles ADMIN */
    RemarketingPublicationCollection: RemarketingPublicationCollection
    /** undefined Only available with roles ADMIN */
    RemarketingPricingPreview: RemarketingPricingPreview
    /** undefined Only available with roles ADMIN */
    allTeslaOptions: Array<TeslaOption>
    /** undefined Only available with roles ADMIN */
    allRemarketingChannels: Array<RemarketingChannel>
    /** undefined Only available when authenticated. */
    searchCompany?: Maybe<Array<Maybe<CompanySearchResult>>>
    /** undefined Only available when authenticated. */
    Company?: Maybe<Company>
    /** undefined Only available when authenticated. */
    CompanyBranch?: Maybe<CompanyBranch>
    Brand?: Maybe<ConfigurationBrandResult>
    Brands?: Maybe<Array<Maybe<ConfigurationBrandResult>>>
    ConfigurationModel?: Maybe<ConfigurationModelResult>
    ConfigurationModels?: Maybe<Array<Maybe<ConfigurationModelResult>>>
    ConfigurationEdition?: Maybe<ConfigurationEditionResult>
    ConfigurationEditions?: Maybe<Array<Maybe<ConfigurationEditionResult>>>
    ValidateEdition?: Maybe<EditionValidation>
    /** undefined Only available with roles ADMIN */
    EditionOption?: Maybe<ConfigurationEditionOptionResult>
    /** undefined Only available with roles ADMIN */
    EditionOptionsByEditionId?: Maybe<Array<Maybe<EditionOption>>>
    Option?: Maybe<ConfigurationOptionResult>
    Options?: Maybe<Array<Maybe<ConfigurationOptionResult>>>
    /** undefined Only available with roles ADMIN */
    ResidualValueTable?: Maybe<ResidualValueTableResult>
    /** undefined Only available with roles ADMIN */
    allResidualValueTables?: Maybe<Array<Maybe<ResidualValueTableResult>>>
    Accessories?: Maybe<Array<Maybe<Accessory>>>
    /** undefined Only available with roles ADMIN */
    PricingConfigurationCalculation?: Maybe<ConfigurationCalculationResult>
    /** undefined Only available with roles ADMIN */
    PricingConfigurationCalculationCollection?: Maybe<ConfigurationCalculationCollection>
    /** undefined Only available with roles ADMIN */
    PricingPreview?: Maybe<PricingPreview>
    /** undefined Only available when authenticated. */
    Contract?: Maybe<Contract>
    /** undefined Only available with roles ADMIN */
    ContractCollection?: Maybe<ContractCollection>
    /** undefined Only available when authenticated. */
    myContracts?: Maybe<Array<Maybe<Contract>>>
    /** undefined Only available with roles ADMIN */
    ContractRecalculation?: Maybe<ContractRecalculation>
    /** undefined Only available with roles ADMIN */
    EndContractProposition?: Maybe<EndContractProposition>
    /** undefined Only available with roles ADMIN */
    UpgradeProposition?: Maybe<UpgradeProposition>
    /** undefined Only available with roles ADMIN */
    AccessoryProposition?: Maybe<AccessoryProposition>
    findReportingcode: ReportingCodeResult
    Deal: Deal
    DealByShopCarId: Deal
    DealByModelId: Deal
    /** undefined Only available when authenticated. */
    DealCollection?: Maybe<DealCollection>
    BanksAvailableForIdeal: Array<Bank>
    DealContractPdf: DealContractPdf
    Signature?: Maybe<Signature>
    generateCoverPage: Scalars['String']
    /** undefined Only available with roles ADMIN */
    Document?: Maybe<Document>
    /** undefined Only available with roles ADMIN */
    DocumentCollection?: Maybe<DocumentCollection>
    /** undefined Only available with roles ADMIN */
    EmailTemplateCollection?: Maybe<EmailTemplateCollection>
    /** undefined Only available with roles ADMIN */
    EmailTemplate?: Maybe<EmailTemplate>
    EventCollection?: Maybe<EventCollection>
    /** undefined Only available when authenticated. */
    getOnfidoSDKToken?: Maybe<OnfidoSdkToken>
    /** undefined Only available when authenticated. */
    getIdCheckStatus?: Maybe<IdCheckStatus>
    /** undefined Only available with roles ADMIN */
    getIdCheckStatusByUserId?: Maybe<IdCheckStatus>
    /** undefined Only available with roles ADMIN */
    getOnfidoReport?: Maybe<Scalars['String']>
    /** undefined Only available with roles ADMIN */
    LeasewiseOfferStatus?: Maybe<LeasewiseOfferStatus>
    /** undefined Only available with roles ADMIN */
    AutodiskModel?: Maybe<AutodiskModel>
    /** undefined Only available with roles ADMIN */
    AutodiskEdition?: Maybe<AutodiskEdition>
    /** undefined Only available with roles ADMIN */
    AutodiskEditionByConfigurationEditionId?: Maybe<AutodiskEdition>
    /** undefined Only available with roles ADMIN */
    AutodiskModelByConfigurationModelId?: Maybe<AutodiskModel>
    /** undefined Only available when authenticated. */
    MyLegalDocumentAgreements: Array<Maybe<LegalDocumentAgreement>>
    /** undefined Only available with roles ADMIN */
    LegalDocumentAgreements: Array<Maybe<LegalDocumentAgreement>>
    /** undefined Only available with roles ADMIN */
    LegalDocumentAgreement: LegalDocumentAgreement
    /** undefined Only available when authenticated. */
    createLegalDocumentAgreementTemplate?: Maybe<LegalDocumentAgreementTemplate>
    /** undefined Only available with roles ADMIN */
    LegalDocumentContent?: Maybe<LegalDocumentContent>
    getLegalDocumentContent?: Maybe<LegalDocumentContent>
    /** undefined Only available with roles ADMIN */
    getAllLegalDocumentContent?: Maybe<Array<Maybe<LegalDocumentContent>>>
    LegalDocument?: Maybe<LegalDocument>
    getAllLegalDocuments: Array<Maybe<LegalDocument>>
    TenantSettings?: Maybe<TenantSettings>
    UserProfile?: Maybe<UserProfile>
    /** undefined Only available when authenticated. */
    myUserProfile?: Maybe<UserProfile>
    /** undefined Only available with roles ADMIN */
    allUserProfiles?: Maybe<AllUserProfilesResult>
    FirstName: Scalars['String']
    /** undefined Only available with roles ADMIN,ACCOUNTMANAGER */
    getAccountManagers?: Maybe<Array<Maybe<UserProfile>>>
    /** undefined Only available with roles ADMIN */
    WorkflowCollection?: Maybe<WorkflowCollection>
    /** undefined Only available with roles ADMIN */
    Workflow?: Maybe<Workflow>
    /** undefined Only available with roles ADMIN */
    allExposedEntities?: Maybe<Array<Maybe<Entity>>>
    /** undefined Only available with roles ADMIN */
    allReceiverEmailOptions?: Maybe<Array<Maybe<Scalars['String']>>>
}

export type QueryLookupAddressArgs = {
    input: LookupAddressInput
}

export type QueryIsRootTokenArgs = {
    token: Scalars['String']
}

export type QueryUserArgs = {
    emailAddress?: Maybe<Scalars['String']>
    id?: Maybe<Scalars['ID']>
}

export type QueryValidateSignupUserArgs = {
    emailAddress?: Maybe<Scalars['String']>
}

export type QueryGetUsersByRoleArgs = {
    role: Role
}

export type QueryCarArgs = {
    id: Scalars['ID']
}

export type QueryCarCollectionArgs = {
    filter?: Maybe<CarFilter>
    pagination?: Maybe<Pagination>
    orderBy?: Maybe<OrderBy>
}

export type QueryRemarketingPublicationCollectionArgs = {
    filter?: Maybe<RemarketingPublicationFilter>
    pagination?: Maybe<Pagination>
    orderBy?: Maybe<OrderBy>
}

export type QueryRemarketingPricingPreviewArgs = {
    carId: Scalars['ID']
    pricingConfigurationId?: Maybe<Scalars['String']>
}

export type QuerySearchCompanyArgs = {
    nameOrChamberOfCommerceNr: Scalars['String']
}

export type QueryCompanyArgs = {
    chamberOfCommerceNr: Scalars['String']
}

export type QueryCompanyBranchArgs = {
    branchNr: Scalars['String']
}

export type QueryBrandArgs = {
    id?: Maybe<Scalars['ID']>
    name?: Maybe<Scalars['String']>
}

export type QueryConfigurationModelArgs = {
    id?: Maybe<Scalars['ID']>
    name?: Maybe<Scalars['String']>
    brandName?: Maybe<Scalars['String']>
}

export type QueryConfigurationEditionArgs = {
    id?: Maybe<Scalars['ID']>
    name?: Maybe<Scalars['String']>
    modelName?: Maybe<Scalars['String']>
}

export type QueryConfigurationEditionsArgs = {
    modelId: Scalars['ID']
}

export type QueryValidateEditionArgs = {
    editionId: Scalars['ID']
    optionIds?: Maybe<Array<Maybe<Scalars['String']>>>
}

export type QueryEditionOptionArgs = {
    id: Scalars['ID']
}

export type QueryEditionOptionsByEditionIdArgs = {
    editionId: Scalars['ID']
}

export type QueryOptionArgs = {
    id: Scalars['ID']
}

export type QueryResidualValueTableArgs = {
    id: Scalars['ID']
}

export type QueryPricingConfigurationCalculationArgs = {
    id: Scalars['ID']
}

export type QueryPricingConfigurationCalculationCollectionArgs = {
    filter?: Maybe<PricingConfigurationCalculationFilter>
    pagination?: Maybe<Pagination>
    orderBy?: Maybe<OrderBy>
}

export type QueryPricingPreviewArgs = {
    input?: Maybe<PricingPreviewInput>
}

export type QueryContractArgs = {
    id: Scalars['ID']
}

export type QueryContractCollectionArgs = {
    filter?: Maybe<ContractFilter>
    pagination?: Maybe<Pagination>
    orderBy?: Maybe<OrderBy>
}

export type QueryContractRecalculationArgs = {
    id: Scalars['ID']
    newTotalMileage: Scalars['Int']
}

export type QueryEndContractPropositionArgs = {
    id: Scalars['ID']
    propositionDate: Scalars['Date']
}

export type QueryUpgradePropositionArgs = {
    id: Scalars['ID']
    propositionDate: Scalars['Date']
}

export type QueryAccessoryPropositionArgs = {
    id: Scalars['ID']
    accessory: Scalars['String']
}

export type QueryFindReportingcodeArgs = {
    licensePlateNumber: Scalars['String']
}

export type QueryDealArgs = {
    id: Scalars['ID']
    showAllEditions?: Maybe<Scalars['Boolean']>
}

export type QueryDealByShopCarIdArgs = {
    shopCarId: Scalars['ID']
}

export type QueryDealByModelIdArgs = {
    modelId: Scalars['String']
}

export type QueryDealCollectionArgs = {
    filter?: Maybe<DealFilter>
    pagination?: Maybe<Pagination>
    orderBy?: Maybe<OrderBy>
}

export type QueryDealContractPdfArgs = {
    dealId: Scalars['ID']
}

export type QuerySignatureArgs = {
    dealId: Scalars['ID']
}

export type QueryGenerateCoverPageArgs = {
    dealId: Scalars['ID']
}

export type QueryDocumentArgs = {
    id: Scalars['ID']
}

export type QueryDocumentCollectionArgs = {
    filter?: Maybe<DocumentFilter>
    pagination?: Maybe<Pagination>
    orderBy?: Maybe<OrderBy>
}

export type QueryEmailTemplateCollectionArgs = {
    filter?: Maybe<EmailTemplateFilter>
    pagination?: Maybe<Pagination>
    orderBy?: Maybe<OrderBy>
}

export type QueryEmailTemplateArgs = {
    id: Scalars['ID']
}

export type QueryEventCollectionArgs = {
    filter?: Maybe<EventFilter>
    pagination?: Maybe<Pagination>
    orderBy?: Maybe<OrderBy>
}

export type QueryGetIdCheckStatusByUserIdArgs = {
    userId?: Maybe<Scalars['ID']>
}

export type QueryGetOnfidoReportArgs = {
    checkId: Scalars['ID']
    reportId: Scalars['ID']
}

export type QueryLeasewiseOfferStatusArgs = {
    dealId: Scalars['ID']
}

export type QueryAutodiskModelArgs = {
    id: Scalars['ID']
}

export type QueryAutodiskEditionArgs = {
    id: Scalars['ID']
}

export type QueryAutodiskEditionByConfigurationEditionIdArgs = {
    configurationEditionId: Scalars['ID']
    entity: LessorEntity
}

export type QueryAutodiskModelByConfigurationModelIdArgs = {
    configurationModelId: Scalars['ID']
    entity: LessorEntity
}

export type QueryLegalDocumentAgreementsArgs = {
    userId?: Maybe<Scalars['String']>
}

export type QueryLegalDocumentAgreementArgs = {
    id?: Maybe<Scalars['ID']>
}

export type QueryCreateLegalDocumentAgreementTemplateArgs = {
    documentId?: Maybe<Scalars['String']>
    slug?: Maybe<Scalars['String']>
    name?: Maybe<Scalars['String']>
    locale?: Maybe<Scalars['String']>
    variables?: Maybe<Array<Maybe<LegalDocumentAgreementVariableInput>>>
    contentId?: Maybe<Scalars['String']>
}

export type QueryLegalDocumentContentArgs = {
    id: Scalars['ID']
}

export type QueryGetLegalDocumentContentArgs = {
    legalDocumentId: Scalars['ID']
}

export type QueryGetAllLegalDocumentContentArgs = {
    legalDocumentId: Scalars['ID']
}

export type QueryLegalDocumentArgs = {
    id?: Maybe<Scalars['ID']>
    slug?: Maybe<Scalars['String']>
    name?: Maybe<Scalars['String']>
    locale?: Maybe<Scalars['String']>
}

export type QueryTenantSettingsArgs = {
    id: Scalars['ID']
}

export type QueryUserProfileArgs = {
    id?: Maybe<Scalars['ID']>
    userId?: Maybe<Scalars['ID']>
    emailAddress?: Maybe<Scalars['String']>
}

export type QueryAllUserProfilesArgs = {
    filter?: Maybe<UserProfileFilter>
    pagination?: Maybe<Pagination>
    orderBy?: Maybe<OrderBy>
}

export type QueryFirstNameArgs = {
    referralCode: Scalars['String']
}

export type QueryWorkflowCollectionArgs = {
    filter?: Maybe<WorkflowFilterInput>
    pagination?: Maybe<Pagination>
    orderBy?: Maybe<OrderBy>
}

export type QueryWorkflowArgs = {
    id: Scalars['ID']
}

export type Ready2ShareValue = {
    __typename?: 'Ready2ShareValue'
    privateMileage: Scalars['Int']
    businessMileage: Scalars['Int']
    privatePrice: Scalars['Float']
    businessPrice: Scalars['Float']
}

export type ReferralProgram = {
    __typename?: 'ReferralProgram'
    id: Scalars['ID']
    name?: Maybe<Scalars['String']>
}

export type RemarketingChannel = {
    id: Scalars['ID']
}

export type RemarketingPricingPreview = {
    __typename?: 'RemarketingPricingPreview'
    pricingConfigurationId?: Maybe<Scalars['String']>
    purchasePriceExVAT: Scalars['Float']
    futureValues: Array<RemarketingValue>
    contractTakeoverValues?: Maybe<Array<RemarketingValue>>
    ready2ShareValues: Array<Ready2ShareValue>
}

export type RemarketingPublication = {
    id: Scalars['ID']
    createdAt: Scalars['Date']
    updatedAt: Scalars['Date']
    carId: Scalars['String']
    channel: RemarketingChannel
    isContractTakeover: Scalars['Boolean']
    pricingConfigurationId?: Maybe<Scalars['String']>
}

export type RemarketingPublicationCollection = PaginatedResult & {
    __typename?: 'RemarketingPublicationCollection'
    remarketingPublications: Array<RemarketingPublication>
    totalResults: Scalars['Int']
}

export type RemarketingPublicationFilter = {
    AND?: Maybe<Array<Maybe<RemarketingPublicationFilter>>>
    OR?: Maybe<Array<Maybe<RemarketingPublicationFilter>>>
    carId?: Maybe<Scalars['String']>
    locale?: Maybe<ShopLocale>
    offerType?: Maybe<ShopOfferType>
}

export type RemarketingValue = {
    __typename?: 'RemarketingValue'
    residualValue?: Maybe<Scalars['Float']>
    duration: Scalars['Int']
    mileage: Scalars['Int']
    leasePriceIncVAT: Scalars['Float']
    leasePriceExVAT: Scalars['Float']
}

export type RemoveCarResult = CarSuccessfullyRemoved | EntityNotFoundError | CarHasContractAttachedError

export enum RemoveConfigurationCalculationResult {
    Removed = 'REMOVED',
    AttachedToEdition = 'ATTACHED_TO_EDITION',
}

export type RenameDocumentInput = {
    name: Scalars['String']
    description?: Maybe<Scalars['String']>
}

export type ReportingCodeResult = {
    __typename?: 'ReportingCodeResult'
    licensePlateNumber?: Maybe<Scalars['String']>
    reportingCode?: Maybe<Scalars['String']>
    brand?: Maybe<Scalars['String']>
    model?: Maybe<Scalars['String']>
    tires?: Maybe<Scalars['Boolean']>
    lastTireChangeBy?: Maybe<Scalars['String']>
    lastTireChangePlace?: Maybe<Scalars['String']>
    winterTires?: Maybe<Scalars['Boolean']>
    currentTire?: Maybe<Scalars['String']>
    lastTireChangeDate?: Maybe<Scalars['Date']>
    tireSizeFront?: Maybe<Scalars['String']>
    tireSizeRear?: Maybe<Scalars['String']>
    entity?: Maybe<Scalars['String']>
    ministryOfTransportDate?: Maybe<Scalars['Date']>
    endDate?: Maybe<Scalars['Date']>
}

export type ResidualValue = {
    __typename?: 'ResidualValue'
    id: Scalars['ID']
    createdAt?: Maybe<Scalars['Date']>
    updatedAt?: Maybe<Scalars['Date']>
    ageInMonths: Scalars['Int']
    mileage: Scalars['Int']
    value: Scalars['Int']
}

export type ResidualValueInput = {
    mileage?: Maybe<Scalars['Int']>
    ageInMonths?: Maybe<Scalars['Int']>
    value?: Maybe<Scalars['Int']>
}

export type ResidualValueTable = {
    __typename?: 'ResidualValueTable'
    id: Scalars['ID']
    name?: Maybe<Scalars['String']>
    residualValues?: Maybe<Array<Maybe<ResidualValue>>>
    editions?: Maybe<Array<Maybe<ConfigurationEdition>>>
}

export type ResidualValueTableInput = {
    name?: Maybe<Scalars['String']>
    residualValues?: Maybe<Array<Maybe<ResidualValueInput>>>
}

export type ResidualValueTableResult = ResidualValueTable | EntityNotFoundError

export type Result = {
    __typename?: 'Result'
    id: Scalars['ID']
    result?: Maybe<Scalars['String']>
}

export type RimsOptionNeededError = ExpectedError & {
    __typename?: 'RimsOptionNeededError'
    errorCode: ErrorCode
}

export enum Role {
    User = 'USER',
    Admin = 'ADMIN',
    TenantAdmin = 'TENANT_ADMIN',
    Accountmanager = 'ACCOUNTMANAGER',
    Superadmin = 'SUPERADMIN',
}

export type SelectableDealOption = {
    __typename?: 'SelectableDealOption'
    id: Scalars['ID']
    createdAt?: Maybe<Scalars['Date']>
    updatedAt?: Maybe<Scalars['Date']>
    key: Scalars['String']
    labelId: Scalars['String']
    value: Value
    selectableValues: Array<Value>
}

export enum ShopCarAvailability {
    Available = 'AVAILABLE',
    Reserved = 'RESERVED',
    NotAvailable = 'NOT_AVAILABLE',
}

export enum ShopLocale {
    NlNl = 'nl_NL',
    NlBe = 'nl_BE',
    FrBe = 'fr_BE',
    FrFr = 'fr_FR',
    DeDe = 'de_DE',
    EsEs = 'es_ES',
    PtPt = 'pt_PT',
    DaDk = 'da_DK',
}

export enum ShopOfferType {
    PrivateLease = 'PRIVATE_LEASE',
    Fol = 'FOL',
    Purchase = 'PURCHASE',
    Ready_2Share = 'READY_2_SHARE',
}

export type Signature = DocumentSignature | IdealSignature

export enum SignatureType {
    DocumentSignature = 'DOCUMENT_SIGNATURE',
    IdealSignature = 'IDEAL_SIGNATURE',
}

export enum SigningMethod {
    DocumentUpload = 'DOCUMENT_UPLOAD',
    Ideal = 'IDEAL',
}

export type SigningPerson = {
    __typename?: 'SigningPerson'
    id: Scalars['ID']
    createdAt?: Maybe<Scalars['Date']>
    updatedAt?: Maybe<Scalars['Date']>
    userId: Scalars['ID']
    emailAddress?: Maybe<Scalars['EmailAddress']>
    signed: Scalars['Boolean']
    signingStatus: SigningStatus
    signature?: Maybe<Signature>
}

export enum SigningStatus {
    Signed = 'SIGNED',
    AwaitingSignature = 'AWAITING_SIGNATURE',
    AwaitingDocumentVerification = 'AWAITING_DOCUMENT_VERIFICATION',
    SignedDocumentRejected = 'SIGNED_DOCUMENT_REJECTED',
}

export type SlackMessage = {
    __typename?: 'SlackMessage'
    id: Scalars['ID']
    createdAt?: Maybe<Scalars['Date']>
    title: Scalars['String']
    content?: Maybe<Scalars['String']>
}

export type SlackMessageInput = {
    title: Scalars['String']
    content?: Maybe<Scalars['String']>
}

export enum Status {
    Configuration = 'CONFIGURATION',
    Offer = 'OFFER',
    ContractIncomplete = 'CONTRACT_INCOMPLETE',
    ContractComplete = 'CONTRACT_COMPLETE',
    ContractOrdered = 'CONTRACT_ORDERED',
    ContractCanceled = 'CONTRACT_CANCELED',
}

export type Tenant = {
    __typename?: 'Tenant'
    id: Scalars['ID']
    name: Scalars['String']
}

export type TenantSettings = {
    __typename?: 'TenantSettings'
    id: Scalars['String']
    tenant: Scalars['String']
    currencyCode: CurrencyCode
    enabledSigningMethods: Array<SigningMethod>
    downpaymentAmounts: Array<Scalars['Int']>
    downpaymentInterestPercentage: Scalars['Float']
    usedCarConfigurationCutOffMileage: Scalars['Int']
    dealLocales?: Maybe<Array<DealLocale>>
}

export type TenantSettingsInput = {
    currencyCode: CurrencyCode
    enabledSigningMethods: Array<SigningMethod>
    downpaymentAmounts: Array<Scalars['Int']>
    downpaymentInterestPercentage: Scalars['Float']
    usedCarConfigurationCutOffMileage: Scalars['Int']
    dealLocales?: Maybe<Array<DealLocale>>
}

export type TeslaOption = {
    __typename?: 'TeslaOption'
    id: Scalars['ID']
    createdAt: Scalars['Date']
    updatedAt: Scalars['Date']
    label: Scalars['String']
    manufacturerCode: Scalars['String']
    category?: Maybe<TeslaOptionCategory>
}

export enum TeslaOptionCategory {
    Autopilot = 'AUTOPILOT',
    Battery = 'BATTERY',
    Interior = 'INTERIOR',
    Paint = 'PAINT',
    Rims = 'RIMS',
    Seating = 'SEATING',
    Towhitch = 'TOWHITCH',
    Wintertires = 'WINTERTIRES',
    Other = 'OTHER',
    Premiumconnectivity = 'PREMIUMCONNECTIVITY',
    Steeringwheel = 'STEERINGWHEEL',
}

export enum Tire {
    Summer = 'SUMMER',
    Winter = 'WINTER',
}

export type UnpublishRemarketingPublicationResult = PublicationSuccessfullyUnpublished | EntityNotFoundError

export type UpgradeProposition = {
    __typename?: 'UpgradeProposition'
    id: Scalars['ID']
    oneTimeFeeExVAT: Scalars['Float']
    oneTimeFeeIncVAT: Scalars['Float']
}

export enum UploadTokenEntity {
    DealDocumentSignature = 'DEAL_DOCUMENT_SIGNATURE',
}

export type UpsertCarResult = Car | EntityNotFoundError | InvalidInputDataError

export type UpsertContractResult = Contract | EntityNotFoundError | InvalidInputDataError

export type User = {
    __typename?: 'User'
    id: Scalars['ID']
    email: Scalars['String']
    emailAddress: Scalars['String']
    createdAt?: Maybe<Scalars['Date']>
    updatedAt?: Maybe<Scalars['Date']>
    roles?: Maybe<Array<Maybe<Role>>>
    tenants?: Maybe<Array<Maybe<Scalars['String']>>>
    profile?: Maybe<UserProfile>
    idCheckStatus?: Maybe<IdCheckStatus>
}

export type UserAddress = {
    __typename?: 'UserAddress'
    id: Scalars['ID']
    createdAt: Scalars['DateTime']
    updatedAt: Scalars['DateTime']
    street?: Maybe<Scalars['String']>
    houseNumber?: Maybe<Scalars['Int']>
    houseNumberSuffix?: Maybe<Scalars['String']>
    zipcode?: Maybe<Scalars['String']>
    city?: Maybe<Scalars['String']>
    userProfile?: Maybe<UserProfile>
}

export type UserAddressInput = {
    street?: Maybe<Scalars['String']>
    houseNumber?: Maybe<Scalars['Int']>
    houseNumberSuffix?: Maybe<Scalars['String']>
    zipcode?: Maybe<Scalars['String']>
    city?: Maybe<Scalars['String']>
    userProfile?: Maybe<UserProfileInput>
}

export type UserProfile = {
    __typename?: 'UserProfile'
    id: Scalars['ID']
    createdAt: Scalars['DateTime']
    updatedAt: Scalars['DateTime']
    address?: Maybe<UserAddress>
    firstName?: Maybe<Scalars['String']>
    legalFirstNames?: Maybe<Scalars['String']>
    lastName?: Maybe<Scalars['String']>
    lastNamePrefix?: Maybe<Scalars['String']>
    telephoneNumber?: Maybe<Scalars['String']>
    emailAddress?: Maybe<Scalars['String']>
    privacyPolicyId?: Maybe<Scalars['String']>
    privacyPolicyApprovedAt?: Maybe<Scalars['String']>
    userId?: Maybe<Scalars['String']>
    referralCode?: Maybe<Scalars['String']>
}

export type UserProfileFilter = {
    AND?: Maybe<Array<Maybe<UserProfileFilter>>>
    OR?: Maybe<Array<Maybe<UserProfileFilter>>>
    emailAddress?: Maybe<Scalars['String']>
    emailAddress_contains?: Maybe<Scalars['String']>
    firstName?: Maybe<Scalars['String']>
    lastName?: Maybe<Scalars['String']>
    fullName?: Maybe<Scalars['String']>
    fullName_contains?: Maybe<Scalars['String']>
    userId?: Maybe<Scalars['String']>
    telephoneNumber?: Maybe<Scalars['String']>
    telephoneNumber_contains?: Maybe<Scalars['String']>
    role?: Maybe<Role>
}

export type UserProfileInput = {
    address?: Maybe<UserAddressInput>
    firstName?: Maybe<Scalars['String']>
    lastName?: Maybe<Scalars['String']>
    lastNamePrefix?: Maybe<Scalars['String']>
    telephoneNumber?: Maybe<Scalars['String']>
    emailAddress?: Maybe<Scalars['String']>
    userId?: Maybe<Scalars['String']>
}

export type Value = {
    __typename?: 'Value'
    id: Scalars['ID']
    label?: Maybe<Scalars['String']>
    labelId: Scalars['String']
    editionLabel?: Maybe<Scalars['String']>
}

export enum WebsiteLocale {
    En = 'en',
    EnGb = 'en_GB',
    Nl = 'nl',
    Fr = 'fr',
    NlNl = 'nl_NL',
    NlBe = 'nl_BE',
    FrBe = 'fr_BE',
    De = 'de',
    DeDe = 'de_DE',
    Pt = 'pt',
    PtPt = 'pt_PT',
    Es = 'es',
    EsEs = 'es_ES',
    Da = 'da',
    DaDk = 'da_DK',
}

export type WheelEditionOption = EditionOptionInterface & {
    __typename?: 'WheelEditionOption'
    id: Scalars['ID']
    createdAt?: Maybe<Scalars['Date']>
    updatedAt?: Maybe<Scalars['Date']>
    labelId?: Maybe<Scalars['String']>
    fiscalValue?: Maybe<Scalars['Int']>
    default?: Maybe<Scalars['Boolean']>
    option?: Maybe<ConfigurationOption>
    edition?: Maybe<ConfigurationEdition>
    price?: Maybe<Scalars['Float']>
}

export type Workflow = {
    __typename?: 'Workflow'
    id: Scalars['ID']
    createdAt?: Maybe<Scalars['Date']>
    updatedAt?: Maybe<Scalars['Date']>
    name?: Maybe<Scalars['String']>
    conditions: Array<WorkflowCondition>
    actions: Array<WorkflowAction>
}

export type WorkflowAction = WorkflowActionBranch | WorkflowActionEmail | WorkflowActionSlack

export type WorkflowActionBranch = {
    __typename?: 'WorkflowActionBranch'
    id: Scalars['ID']
    createdAt?: Maybe<Scalars['Date']>
    updatedAt?: Maybe<Scalars['Date']>
    conditions: Array<WorkflowCondition>
    acceptActions: Array<WorkflowAction>
    rejectActions: Array<WorkflowAction>
}

export type WorkflowActionEmail = {
    __typename?: 'WorkflowActionEmail'
    id: Scalars['ID']
    createdAt?: Maybe<Scalars['Date']>
    updatedAt?: Maybe<Scalars['Date']>
    emailTemplate: EmailTemplate
    senderEmail: Scalars['EmailAddress']
    senderName: Scalars['String']
    receiverEmail: Scalars['String']
}

export type WorkflowActionInput = {
    type: WorkflowActionType
    branchAction?: Maybe<WorkflowBranchActionInput>
    emailAction?: Maybe<WorkflowEmailActionInput>
    slackAction?: Maybe<WorkflowSlackActionInput>
}

export type WorkflowActionSlack = {
    __typename?: 'WorkflowActionSlack'
    id: Scalars['ID']
    createdAt?: Maybe<Scalars['Date']>
    updatedAt?: Maybe<Scalars['Date']>
    channel: Scalars['String']
    message: SlackMessage
}

export enum WorkflowActionType {
    Branch = 'BRANCH',
    Email = 'EMAIL',
    SlackNotification = 'SLACK_NOTIFICATION',
}

export type WorkflowBranchActionInput = {
    conditions: Array<WorkflowConditionInput>
    acceptActions: Array<WorkflowActionInput>
    rejectActions: Array<WorkflowActionInput>
}

export type WorkflowCollection = PaginatedResult & {
    __typename?: 'WorkflowCollection'
    workflows?: Maybe<Array<Maybe<Workflow>>>
    totalResults?: Maybe<Scalars['Int']>
}

export type WorkflowCondition = {
    __typename?: 'WorkflowCondition'
    entity?: Maybe<EntityType>
    requirements: Array<WorkflowRequirement>
}

export type WorkflowConditionInput = {
    entity?: Maybe<EntityType>
    requirements: Array<EntityRequirementInput>
}

export type WorkflowEmailActionInput = {
    emailTemplateId: Scalars['ID']
    senderEmail: Scalars['EmailAddress']
    senderName?: Maybe<Scalars['String']>
    receiverEmail?: Maybe<Scalars['String']>
}

export enum WorkflowEntityFilterType {
    AnyOf = 'ANY_OF',
    IsEqualTo = 'IS_EQUAL_TO',
}

export type WorkflowEntityRequirementFilter = {
    type: WorkflowEntityFilterType
    field?: Maybe<Array<Maybe<Scalars['String']>>>
}

export type WorkflowEvent = {
    __typename?: 'WorkflowEvent'
    id: Scalars['ID']
    entities: Array<WorkflowEventEntity>
}

export type WorkflowEventEntity = {
    __typename?: 'WorkflowEventEntity'
    instanceId: Scalars['ID']
    type: EntityType
}

export type WorkflowEventTypeDefinition = {
    __typename?: 'WorkflowEventTypeDefinition'
    id: Scalars['ID']
    entity?: Maybe<Entity>
    name?: Maybe<Scalars['String']>
    description?: Maybe<Scalars['String']>
}

export type WorkflowFilter = {
    __typename?: 'WorkflowFilter'
    type: WorkflowEntityFilterType
    field?: Maybe<Array<Maybe<Scalars['String']>>>
}

export type WorkflowFilterInput = {
    AND?: Maybe<Array<WorkflowFilterInput>>
    OR?: Maybe<Array<WorkflowFilterInput>>
}

export type WorkflowInput = {
    name: Scalars['String']
    conditions: Array<WorkflowConditionInput>
    actions: Array<WorkflowActionInput>
}

export type WorkflowRequirement = {
    __typename?: 'WorkflowRequirement'
    property: Scalars['String']
    filter: Array<WorkflowFilter>
}

export type WorkflowSlackActionInput = {
    channel: Scalars['String']
    message: SlackMessageInput
}

export type ExchangeForJsonWebTokenMutationVariables = Exact<{
    tokenId: Scalars['ID']
    token: Scalars['String']
}>

export type ExchangeForJsonWebTokenMutation = { __typename?: 'Mutation' } & {
    exchangeForJsonWebToken?: Maybe<{ __typename?: 'JsonWebToken' } & Pick<JsonWebToken, 'token' | 'userId'>>
}

export type GetCurrentUserQueryVariables = Exact<{ [key: string]: never }>

export type GetCurrentUserQuery = { __typename?: 'Query' } & {
    getCurrentUser?: Maybe<{ __typename?: 'User' } & Pick<User, 'id' | 'emailAddress' | 'roles'>>
}

export type RequestLoginEmailMutationVariables = Exact<{
    emailAddress: Scalars['String']
    path: Scalars['String']
}>

export type RequestLoginEmailMutation = { __typename?: 'Mutation' } & Pick<Mutation, 'requestLoginEmail'>

export type SignupUserMutationVariables = Exact<{
    emailAddress: Scalars['String']
}>

export type SignupUserMutation = { __typename?: 'Mutation' } & {
    signupUser?: Maybe<{ __typename?: 'JsonWebToken' } & Pick<JsonWebToken, 'userId' | 'token'>>
}

export type ValidateSignupUserQueryVariables = Exact<{
    emailAddress: Scalars['String']
}>

export type ValidateSignupUserQuery = { __typename?: 'Query' } & Pick<Query, 'validateSignupUser'>

export type TenantCurrencyQueryVariables = Exact<{
    id: Scalars['ID']
}>

export type TenantCurrencyQuery = { __typename?: 'Query' } & {
    TenantSettings?: Maybe<{ __typename?: 'TenantSettings' } & Pick<TenantSettings, 'id' | 'currencyCode'>>
}

export type CancelDealMutationVariables = Exact<{
    id: Scalars['ID']
}>

export type CancelDealMutation = { __typename?: 'Mutation' } & {
    cancelDeal: { __typename?: 'Deal' } & Pick<Deal, 'id' | 'status'>
}

export type ContractQueryVariables = Exact<{
    id: Scalars['ID']
}>

export type ContractQuery = { __typename?: 'Query' } & {
    Contract?: Maybe<
        { __typename?: 'Contract' } & Pick<
            Contract,
            | 'id'
            | 'leasingType'
            | 'mileage'
            | 'duration'
            | 'startDate'
            | 'endDate'
            | 'pricePerMonthExVAT'
            | 'pricePerMonthIncVAT'
            | 'moreKmPrice'
            | 'lessKmPrice'
            | 'winterTires'
            | 'contractNumber'
            | 'status'
            | 'deductible'
            | 'windowBreakDeductible'
            | 'fsd'
            | 'fsdGrowthModel'
            | 'fsdGrowthFee'
        > & {
                lessor?: Maybe<{ __typename?: 'Lessor' } & Pick<Lessor, 'id' | 'name'>>
                lessee?: Maybe<
                    | ({ __typename?: 'ContractCompany' } & Pick<
                          ContractCompany,
                          'id' | 'name' | 'chamberOfCommerceNr' | 'emailAddress' | 'phonenumber'
                      > & {
                              postalAddress?: Maybe<
                                  { __typename?: 'Address' } & Pick<
                                      Address,
                                      'id' | 'street' | 'houseNumber' | 'houseNumberSuffix' | 'zipcode' | 'city'
                                  >
                              >
                          })
                    | ({ __typename?: 'ContractPerson' } & Pick<
                          ContractPerson,
                          'id' | 'emailAddress' | 'phonenumber'
                      > & { fullName: ContractPerson['name'] } & {
                              address?: Maybe<
                                  { __typename?: 'Address' } & Pick<
                                      Address,
                                      'id' | 'street' | 'houseNumber' | 'houseNumberSuffix' | 'zipcode' | 'city'
                                  >
                              >
                          })
                >
                driver?: Maybe<
                    { __typename?: 'ContractDriver' } & Pick<
                        ContractDriver,
                        'firstName' | 'fullName' | 'emailAddress' | 'workPhonenumber' | 'mobilePhonenumber'
                    > & {
                            address?: Maybe<
                                { __typename?: 'Address' } & Pick<
                                    Address,
                                    'id' | 'street' | 'houseNumber' | 'houseNumberSuffix' | 'zipcode' | 'city'
                                >
                            >
                        }
                >
                car?: Maybe<
                    { __typename?: 'Car' } & Pick<
                        Car,
                        | 'VIN'
                        | 'licensePlate'
                        | 'brandName'
                        | 'modelName'
                        | 'editionName'
                        | 'reportingCode'
                        | 'currentTire'
                        | 'lastTireChangeDate'
                        | 'lastTireChangeBy'
                        | 'lastTireChangePlace'
                        | 'ministryOfTransportDate'
                    >
                >
            }
    >
}

export type DealCollectionQueryVariables = Exact<{
    ownerId: Scalars['String']
}>

export type DealCollectionQuery = { __typename?: 'Query' } & {
    DealCollection?: Maybe<
        { __typename?: 'DealCollection' } & {
            deals?: Maybe<
                Array<
                    Maybe<
                        { __typename?: 'Deal' } & Pick<Deal, 'id' | 'editionName' | 'modelName'> & {
                                pricing: { __typename?: 'Pricing' } & Pick<
                                    Pricing,
                                    'pricePerMonthExVAT' | 'pricePerMonthIncVAT' | 'incVAT'
                                >
                            }
                    >
                >
            >
        }
    >
}

export type MyContractsQueryVariables = Exact<{ [key: string]: never }>

export type MyContractsQuery = { __typename?: 'Query' } & {
    myContracts?: Maybe<
        Array<
            Maybe<
                { __typename?: 'Contract' } & Pick<
                    Contract,
                    | 'id'
                    | 'contractNumber'
                    | 'startDate'
                    | 'endDate'
                    | 'winterTires'
                    | 'mileage'
                    | 'duration'
                    | 'status'
                > & {
                        car?: Maybe<
                            { __typename?: 'Car' } & Pick<
                                Car,
                                'VIN' | 'licensePlate' | 'brandName' | 'modelName' | 'editionName'
                            >
                        >
                    }
            >
        >
    >
}

export type ConfigurationModelsForCheckoutQueryVariables = Exact<{ [key: string]: never }>

export type ConfigurationModelsForCheckoutQuery = { __typename?: 'Query' } & {
    ConfigurationModels?: Maybe<
        Array<
            Maybe<
                | ({ __typename?: 'ConfigurationModel' } & Pick<ConfigurationModel, 'id'> & {
                          editions?: Maybe<
                              Array<
                                  Maybe<
                                      { __typename?: 'ConfigurationEdition' } & Pick<
                                          ConfigurationEdition,
                                          'id' | 'fiscalValue'
                                      >
                                  >
                              >
                          >
                      })
                | { __typename?: 'EntityNotFoundError' }
            >
        >
    >
}

export type CreateDealMutationVariables = Exact<{
    input: DealInput
}>

export type CreateDealMutation = { __typename?: 'Mutation' } & {
    createDeal: { __typename?: 'Deal' } & BaseDealConfigurationFieldsFragment
}

export type DealByModelIdQueryVariables = Exact<{
    modelId: Scalars['String']
}>

export type DealByModelIdQuery = { __typename?: 'Query' } & {
    DealByModelId: { __typename?: 'Deal' } & BaseDealConfigurationFieldsFragment
}

export type BanksAvailableForIdealQueryVariables = Exact<{ [key: string]: never }>

export type BanksAvailableForIdealQuery = { __typename?: 'Query' } & {
    BanksAvailableForIdeal: Array<{ __typename?: 'Bank' } & Pick<Bank, 'id' | 'name'>>
}

export type LookupAddressQueryVariables = Exact<{
    input: LookupAddressInput
}>

export type LookupAddressQuery = { __typename?: 'Query' } & {
    LookupAddress?: Maybe<{ __typename?: 'LookupAddress' } & Pick<LookupAddress, 'id' | 'street' | 'city'>>
}

export type AcceptDealOfferMutationVariables = Exact<{
    id: Scalars['ID']
}>

export type AcceptDealOfferMutation = { __typename?: 'Mutation' } & {
    acceptDealOffer: { __typename?: 'Deal' } & Pick<Deal, 'id' | 'status'>
}

export type AddSigningPersonToDealMutationVariables = Exact<{
    id: Scalars['ID']
    email: Scalars['EmailAddress']
}>

export type AddSigningPersonToDealMutation = { __typename?: 'Mutation' } & {
    addSigningpersonToDeal: { __typename?: 'Deal' } & Pick<Deal, 'id'> & {
            signingPersons: Array<{ __typename?: 'SigningPerson' } & SigningPersonFragmentFragment>
        }
}

export type CreateDealDocumentUploadTokenMutationVariables = Exact<{
    id: Scalars['ID']
}>

export type CreateDealDocumentUploadTokenMutation = { __typename?: 'Mutation' } & Pick<
    Mutation,
    'createDealDocumentUploadToken'
>

export type CreateLegalDocumentAgreementTemplateByNameQueryVariables = Exact<{
    name?: Maybe<Scalars['String']>
    locale?: Maybe<Scalars['String']>
    variables?: Maybe<Array<Maybe<LegalDocumentAgreementVariableInput>> | Maybe<LegalDocumentAgreementVariableInput>>
}>

export type CreateLegalDocumentAgreementTemplateByNameQuery = { __typename?: 'Query' } & {
    createLegalDocumentAgreementTemplate?: Maybe<
        { __typename?: 'LegalDocumentAgreementTemplate' } & Pick<
            LegalDocumentAgreementTemplate,
            'hash' | 'title' | 'body' | 'agreement' | 'summary' | 'name' | 'locale'
        >
    >
}

export type DealConfigurationQueryVariables = Exact<{
    id: Scalars['ID']
}>

export type DealConfigurationQuery = { __typename?: 'Query' } & {
    Deal: { __typename?: 'Deal' } & BaseDealConfigurationFieldsFragment
}

export type DealOfferQueryVariables = Exact<{
    id: Scalars['ID']
}>

export type DealOfferQuery = { __typename?: 'Query' } & {
    Deal: { __typename?: 'Deal' } & Pick<Deal, 'internalOwnerId' | 'status' | 'remarks' | 'optionsDescription'> & {
            requirements: { __typename?: 'DealRequirements' } & DealRequirementsFragmentFragment
        } & BaseDealFieldsFragment
}

export type DealContractQueryVariables = Exact<{
    id: Scalars['ID']
}>

export type DealContractQuery = { __typename?: 'Query' } & {
    Deal: { __typename?: 'Deal' } & Pick<
        Deal,
        | 'legalDocumentNames'
        | 'internalOwnerId'
        | 'manufacturerReferralCode'
        | 'manufacturerAccountEmailAddress'
        | 'status'
        | 'remarks'
    > & {
            requirements: { __typename?: 'DealRequirements' } & DealRequirementsFragmentFragment
            signingPersons: Array<{ __typename?: 'SigningPerson' } & SigningPersonFragmentFragment>
            contact?: Maybe<{ __typename?: 'DealContact' } & ContactFragmentFragment>
            billingAccount?: Maybe<{ __typename?: 'BillingAccount' } & BillingAccountFragmentFragment>
        } & BaseDealFieldsFragment
}

export type DealContractPdfQueryVariables = Exact<{
    dealId: Scalars['ID']
}>

export type DealContractPdfQuery = { __typename?: 'Query' } & {
    DealContractPdf: { __typename?: 'DealContractPdf' } & Pick<DealContractPdf, 'dealId' | 'url'>
}

export type BooleanDealOptionFragmentFragment = { __typename?: 'BooleanDealOption' } & Pick<
    BooleanDealOption,
    'id' | 'key' | 'value'
>

export type DealRequirementsFragmentFragment = { __typename?: 'DealRequirements' } & Pick<
    DealRequirements,
    'id' | 'isCompanyRequired' | 'isDriverRequired'
>

export type SelectableDealOptionFragmentFragment = { __typename?: 'SelectableDealOption' } & Pick<
    SelectableDealOption,
    'id'
> & { name: SelectableDealOption['key'] } & {
        selectedValue: { __typename?: 'Value' } & Pick<Value, 'id' | 'label' | 'labelId'>
        selectableValues: Array<{ __typename?: 'Value' } & Pick<Value, 'id' | 'label' | 'labelId'>>
    }

export type LesseeCompanyFragmentFragment = { __typename?: 'LesseeCompany' } & Pick<
    LesseeCompany,
    'id' | 'chamberOfCommerceNr' | 'name' | 'kvkStatus' | 'kcStatus'
> & {
        postalAddress?: Maybe<
            { __typename?: 'Address' } & Pick<
                Address,
                'id' | 'street' | 'houseNumber' | 'houseNumberSuffix' | 'zipcode' | 'city'
            >
        >
    }

export type LesseePersonFragmentFragment = { __typename?: 'LesseePerson' } & Pick<
    LesseePerson,
    'id' | 'userId' | 'emailAddress' | 'phonenumber' | 'firstName' | 'lastName' | 'lastNamePrefix'
> & { personKcStatus: LesseePerson['kcStatus'] } & {
        address?: Maybe<
            { __typename?: 'Address' } & Pick<
                Address,
                'id' | 'street' | 'houseNumber' | 'houseNumberSuffix' | 'zipcode' | 'city'
            >
        >
    }

export type DriverFragmentFragment = { __typename?: 'DealDriver' } & Pick<
    DealDriver,
    'id' | 'userId' | 'emailAddress' | 'phonenumber' | 'licenseVerified' | 'firstName' | 'lastName' | 'lastNamePrefix'
> & {
        address?: Maybe<
            { __typename?: 'Address' } & Pick<
                Address,
                'id' | 'street' | 'houseNumber' | 'houseNumberSuffix' | 'zipcode' | 'city'
            >
        >
    }

export type PricingFragmentFragment = { __typename?: 'Pricing' } & Pick<
    Pricing,
    | 'id'
    | 'pricePerMonthIncVAT'
    | 'pricePerMonthExVAT'
    | 'lessKmPriceExVAT'
    | 'moreKmPriceExVAT'
    | 'privateLeaseLessKmPriceIncVAT'
    | 'privateLeaseMoreKmPriceIncVAT'
    | 'incVAT'
    | 'fiscalValue'
>

export type SigningPersonFragmentFragment = { __typename?: 'SigningPerson' } & Pick<
    SigningPerson,
    'id' | 'userId' | 'emailAddress' | 'signed' | 'signingStatus'
> & {
        signature?: Maybe<
            | { __typename?: 'DocumentSignature' }
            | ({ __typename?: 'IdealSignature' } & Pick<
                  IdealSignature,
                  'id' | 'accountName' | 'iban' | 'paymentId' | 'status'
              >)
        >
    }

export type ContactFragmentFragment = { __typename?: 'DealContact' } & Pick<
    DealContact,
    'id' | 'firstName' | 'lastNamePrefix' | 'lastName' | 'emailAddress' | 'phonenumber'
>

export type BillingAccountFragmentFragment = { __typename?: 'BillingAccount' } & Pick<
    BillingAccount,
    'id' | 'accountHolder' | 'iban' | 'emailAddress'
>

export type BaseDealConfigurationFieldsFragment = { __typename?: 'Deal' } & Pick<Deal, 'status'> & {
        requirements: { __typename?: 'DealRequirements' } & DealRequirementsFragmentFragment
    } & BaseDealFieldsFragment

export type BaseDealFieldsFragment = { __typename?: 'Deal' } & Pick<
    Deal,
    'id' | 'userId' | 'referralCode' | 'dealType' | 'modelName' | 'editionName' | 'calculationComponents'
> & {
        options: Array<
            | ({ __typename?: 'BooleanDealOption' } & BooleanDealOptionFragmentFragment)
            | ({ __typename?: 'SelectableDealOption' } & SelectableDealOptionFragmentFragment)
        >
        lessee?: Maybe<
            | ({ __typename?: 'LesseeCompany' } & LesseeCompanyFragmentFragment)
            | ({ __typename?: 'LesseePerson' } & LesseePersonFragmentFragment)
        >
        driver?: Maybe<{ __typename?: 'DealDriver' } & DriverFragmentFragment>
        pricing: { __typename?: 'Pricing' } & PricingFragmentFragment
        referralProgram?: Maybe<{ __typename?: 'ReferralProgram' } & Pick<ReferralProgram, 'id' | 'name'>>
    }

export type EnabledSigningMethodsQueryVariables = Exact<{
    id: Scalars['ID']
}>

export type EnabledSigningMethodsQuery = { __typename?: 'Query' } & {
    TenantSettings?: Maybe<{ __typename?: 'TenantSettings' } & Pick<TenantSettings, 'enabledSigningMethods'>>
}

export type MakeDealOfferMutationVariables = Exact<{
    dealId: Scalars['ID']
}>

export type MakeDealOfferMutation = { __typename?: 'Mutation' } & {
    makeDealOffer: { __typename?: 'Deal' } & Pick<Deal, 'id' | 'status'>
}

export type SignViaIdealMutationVariables = Exact<{
    id: Scalars['ID']
    bankId: Scalars['String']
    callbackPath: Scalars['String']
}>

export type SignViaIdealMutation = { __typename?: 'Mutation' } & Pick<Mutation, 'signViaIdeal'>

export type SigningPersonsQueryVariables = Exact<{
    id: Scalars['ID']
}>

export type SigningPersonsQuery = { __typename?: 'Query' } & {
    Deal: { __typename?: 'Deal' } & Pick<Deal, 'id'> & {
            signingPersons: Array<{ __typename?: 'SigningPerson' } & SigningPersonFragmentFragment>
        }
}

export type UpdateBooleanDealOptionMutationVariables = Exact<{
    id: Scalars['ID']
    dealOptionId: Scalars['ID']
    value: Scalars['Boolean']
}>

export type UpdateBooleanDealOptionMutation = { __typename?: 'Mutation' } & {
    updateBooleanDealOption: { __typename?: 'Deal' } & {
        requirements: { __typename?: 'DealRequirements' } & DealRequirementsFragmentFragment
    } & BaseDealFieldsFragment
}

export type UpdateDealBillingMutationVariables = Exact<{
    id: Scalars['ID']
    input: DealBillingInput
}>

export type UpdateDealBillingMutation = { __typename?: 'Mutation' } & {
    updateDealBilling: { __typename?: 'Deal' } & Pick<Deal, 'id'> & {
            billingAccount?: Maybe<{ __typename?: 'BillingAccount' } & BillingAccountFragmentFragment>
        }
}

export type UpdateDealContactMutationVariables = Exact<{
    id: Scalars['ID']
    input?: Maybe<DealContactInput>
}>

export type UpdateDealContactMutation = { __typename?: 'Mutation' } & {
    updateDealContact: { __typename?: 'Deal' } & Pick<Deal, 'id'> & {
            contact?: Maybe<{ __typename?: 'DealContact' } & ContactFragmentFragment>
        }
}

export type UpdateDealDriverMutationVariables = Exact<{
    id: Scalars['ID']
    email?: Maybe<Scalars['String']>
}>

export type UpdateDealDriverMutation = { __typename?: 'Mutation' } & {
    updateDealDriver: { __typename?: 'Deal' } & Pick<Deal, 'id'> & {
            driver?: Maybe<{ __typename?: 'DealDriver' } & DriverFragmentFragment>
        }
}

export type UpdateDealLesseeMutationVariables = Exact<{
    id: Scalars['ID']
    input?: Maybe<CompanyInput>
}>

export type UpdateDealLesseeMutation = { __typename?: 'Mutation' } & {
    updateDealLessee: { __typename?: 'Deal' } & Pick<Deal, 'id'> & {
            lessee?: Maybe<
                | ({ __typename?: 'LesseeCompany' } & LesseeCompanyFragmentFragment)
                | ({ __typename?: 'LesseePerson' } & LesseePersonFragmentFragment)
            >
        }
}

export type UpdateDealManufacturerAccountEmailAddressMutationVariables = Exact<{
    id: Scalars['ID']
    email: Scalars['EmailAddress']
}>

export type UpdateDealManufacturerAccountEmailAddressMutation = { __typename?: 'Mutation' } & {
    updateDealManufacturerAccountEmailAddress: { __typename?: 'Deal' } & Pick<
        Deal,
        'id' | 'manufacturerAccountEmailAddress'
    >
}

export type UpdateDealManufacturerReferralCodeMutationVariables = Exact<{
    id: Scalars['ID']
    code: Scalars['String']
}>

export type UpdateDealManufacturerReferralCodeMutation = { __typename?: 'Mutation' } & {
    updateDealManufacturerReferralCode: { __typename?: 'Deal' } & Pick<Deal, 'id' | 'manufacturerReferralCode'>
}

export type UpdateDealReferralCodeMutationVariables = Exact<{
    id: Scalars['ID']
    code: Scalars['String']
}>

export type UpdateDealReferralCodeMutation = { __typename?: 'Mutation' } & {
    updateDealReferralCode: { __typename?: 'Deal' } & Pick<Deal, 'id' | 'referralCode'> & {
            referralProgram?: Maybe<{ __typename?: 'ReferralProgram' } & Pick<ReferralProgram, 'id' | 'name'>>
            pricing: { __typename?: 'Pricing' } & PricingFragmentFragment
        }
}

export type UpdateSelectableDealOptionMutationVariables = Exact<{
    id: Scalars['ID']
    dealOptionId: Scalars['ID']
    valueId: Scalars['ID']
}>

export type UpdateSelectableDealOptionMutation = { __typename?: 'Mutation' } & {
    updateSelectableDealOption: { __typename?: 'Deal' } & {
        requirements: { __typename?: 'DealRequirements' } & DealRequirementsFragmentFragment
    } & BaseDealFieldsFragment
}

export type UploadDocumentMutationVariables = Exact<{
    input: DocumentInput
}>

export type UploadDocumentMutation = { __typename?: 'Mutation' } & {
    uploadDocument?: Maybe<{ __typename?: 'Document' } & Pick<Document, 'id'>>
}

export type UserProfileQueryVariables = Exact<{
    userId?: Maybe<Scalars['ID']>
}>

export type UserProfileQuery = { __typename?: 'Query' } & {
    UserProfile?: Maybe<
        { __typename?: 'UserProfile' } & Pick<UserProfile, 'id' | 'firstName' | 'emailAddress' | 'telephoneNumber'>
    >
}

export const SigningPersonFragmentFragmentDoc = gql`
    fragment SigningPersonFragment on SigningPerson {
        id
        userId
        emailAddress
        signed
        signingStatus
        signature {
            ... on IdealSignature {
                id
                accountName
                iban
                paymentId
                status
            }
        }
    }
`
export const ContactFragmentFragmentDoc = gql`
    fragment ContactFragment on DealContact {
        id
        firstName
        lastNamePrefix
        lastName
        emailAddress
        phonenumber
    }
`
export const BillingAccountFragmentFragmentDoc = gql`
    fragment BillingAccountFragment on BillingAccount {
        id
        accountHolder
        iban
        emailAddress
    }
`
export const BooleanDealOptionFragmentFragmentDoc = gql`
    fragment BooleanDealOptionFragment on BooleanDealOption {
        id
        key
        value
    }
`
export const SelectableDealOptionFragmentFragmentDoc = gql`
    fragment SelectableDealOptionFragment on SelectableDealOption {
        id
        name: key
        selectedValue: value {
            id
            label
            labelId
        }
        selectableValues {
            id
            label
            labelId
        }
    }
`
export const LesseeCompanyFragmentFragmentDoc = gql`
    fragment LesseeCompanyFragment on LesseeCompany {
        id
        chamberOfCommerceNr
        name
        postalAddress {
            id
            street
            houseNumber
            houseNumberSuffix
            zipcode
            city
        }
        kvkStatus
        kcStatus
    }
`
export const LesseePersonFragmentFragmentDoc = gql`
    fragment LesseePersonFragment on LesseePerson {
        id
        userId
        emailAddress
        phonenumber
        address {
            id
            street
            houseNumber
            houseNumberSuffix
            zipcode
            city
        }
        firstName
        lastName
        lastNamePrefix
        personKcStatus: kcStatus
    }
`
export const DriverFragmentFragmentDoc = gql`
    fragment DriverFragment on DealDriver {
        id
        userId
        emailAddress
        phonenumber
        address {
            id
            street
            houseNumber
            houseNumberSuffix
            zipcode
            city
        }
        licenseVerified
        firstName
        lastName
        lastNamePrefix
    }
`
export const PricingFragmentFragmentDoc = gql`
    fragment PricingFragment on Pricing {
        id
        pricePerMonthIncVAT
        pricePerMonthExVAT
        lessKmPriceExVAT
        moreKmPriceExVAT
        privateLeaseLessKmPriceIncVAT
        privateLeaseMoreKmPriceIncVAT
        incVAT
        fiscalValue
    }
`
export const BaseDealFieldsFragmentDoc = gql`
    fragment baseDealFields on Deal {
        id
        userId
        options {
            ... on BooleanDealOption {
                ...BooleanDealOptionFragment
            }
            ... on SelectableDealOption {
                ...SelectableDealOptionFragment
            }
        }
        lessee {
            ... on LesseeCompany {
                ...LesseeCompanyFragment
            }
            ... on LesseePerson {
                ...LesseePersonFragment
            }
        }
        driver {
            ...DriverFragment
        }
        pricing {
            ...PricingFragment
        }
        referralCode
        referralProgram {
            id
            name
        }
        dealType
        modelName
        editionName
        calculationComponents
    }
    ${BooleanDealOptionFragmentFragmentDoc}
    ${SelectableDealOptionFragmentFragmentDoc}
    ${LesseeCompanyFragmentFragmentDoc}
    ${LesseePersonFragmentFragmentDoc}
    ${DriverFragmentFragmentDoc}
    ${PricingFragmentFragmentDoc}
`
export const DealRequirementsFragmentFragmentDoc = gql`
    fragment DealRequirementsFragment on DealRequirements {
        id
        isCompanyRequired
        isDriverRequired
    }
`
export const BaseDealConfigurationFieldsFragmentDoc = gql`
    fragment baseDealConfigurationFields on Deal {
        ...baseDealFields
        status
        requirements {
            ...DealRequirementsFragment
        }
    }
    ${BaseDealFieldsFragmentDoc}
    ${DealRequirementsFragmentFragmentDoc}
`
export const ExchangeForJsonWebTokenDocument = gql`
    mutation exchangeForJsonWebToken($tokenId: ID!, $token: String!) {
        exchangeForJsonWebToken(loginTokenId: $tokenId, loginToken: $token) {
            token
            userId
        }
    }
`

@Injectable({
    providedIn: 'root',
})
export class ExchangeForJsonWebTokenGQL extends Apollo.Mutation<
    ExchangeForJsonWebTokenMutation,
    ExchangeForJsonWebTokenMutationVariables
> {
    document = ExchangeForJsonWebTokenDocument

    constructor(apollo: Apollo.Apollo) {
        super(apollo)
    }
}
export const GetCurrentUserDocument = gql`
    query getCurrentUser {
        getCurrentUser {
            id
            emailAddress
            roles
        }
    }
`

@Injectable({
    providedIn: 'root',
})
export class GetCurrentUserGQL extends Apollo.Query<GetCurrentUserQuery, GetCurrentUserQueryVariables> {
    document = GetCurrentUserDocument

    constructor(apollo: Apollo.Apollo) {
        super(apollo)
    }
}
export const RequestLoginEmailDocument = gql`
    mutation requestLoginEmail($emailAddress: String!, $path: String!) {
        requestLoginEmail(email: $emailAddress, path: $path)
    }
`

@Injectable({
    providedIn: 'root',
})
export class RequestLoginEmailGQL extends Apollo.Mutation<
    RequestLoginEmailMutation,
    RequestLoginEmailMutationVariables
> {
    document = RequestLoginEmailDocument

    constructor(apollo: Apollo.Apollo) {
        super(apollo)
    }
}
export const SignupUserDocument = gql`
    mutation signupUser($emailAddress: String!) {
        signupUser(emailAddress: $emailAddress) {
            userId
            token
        }
    }
`

@Injectable({
    providedIn: 'root',
})
export class SignupUserGQL extends Apollo.Mutation<SignupUserMutation, SignupUserMutationVariables> {
    document = SignupUserDocument

    constructor(apollo: Apollo.Apollo) {
        super(apollo)
    }
}
export const ValidateSignupUserDocument = gql`
    query validateSignupUser($emailAddress: String!) {
        validateSignupUser(emailAddress: $emailAddress)
    }
`

@Injectable({
    providedIn: 'root',
})
export class ValidateSignupUserGQL extends Apollo.Query<ValidateSignupUserQuery, ValidateSignupUserQueryVariables> {
    document = ValidateSignupUserDocument

    constructor(apollo: Apollo.Apollo) {
        super(apollo)
    }
}
export const TenantCurrencyDocument = gql`
    query TenantCurrency($id: ID!) {
        TenantSettings(id: $id) {
            id
            currencyCode
        }
    }
`

@Injectable({
    providedIn: 'root',
})
export class TenantCurrencyGQL extends Apollo.Query<TenantCurrencyQuery, TenantCurrencyQueryVariables> {
    document = TenantCurrencyDocument

    constructor(apollo: Apollo.Apollo) {
        super(apollo)
    }
}
export const CancelDealDocument = gql`
    mutation cancelDeal($id: ID!) {
        cancelDeal(id: $id) {
            id
            status
        }
    }
`

@Injectable({
    providedIn: 'root',
})
export class CancelDealGQL extends Apollo.Mutation<CancelDealMutation, CancelDealMutationVariables> {
    document = CancelDealDocument

    constructor(apollo: Apollo.Apollo) {
        super(apollo)
    }
}
export const ContractDocument = gql`
    query Contract($id: ID!) {
        Contract(id: $id) {
            id
            leasingType
            lessor {
                id
                name
            }
            lessee {
                ... on ContractCompany {
                    id
                    name
                    chamberOfCommerceNr
                    emailAddress
                    phonenumber
                    postalAddress {
                        id
                        street
                        houseNumber
                        houseNumberSuffix
                        zipcode
                        city
                    }
                }
                ... on ContractPerson {
                    id
                    emailAddress
                    phonenumber
                    address {
                        id
                        street
                        houseNumber
                        houseNumberSuffix
                        zipcode
                        city
                    }
                    fullName: name
                }
            }
            driver {
                firstName
                fullName
                emailAddress
                workPhonenumber
                mobilePhonenumber
                address {
                    id
                    street
                    houseNumber
                    houseNumberSuffix
                    zipcode
                    city
                }
            }
            car {
                VIN
                licensePlate
                brandName
                modelName
                editionName
                reportingCode
                currentTire
                lastTireChangeDate
                lastTireChangeBy
                lastTireChangePlace
                ministryOfTransportDate
            }
            mileage
            duration
            startDate
            endDate
            pricePerMonthExVAT
            pricePerMonthIncVAT
            moreKmPrice
            lessKmPrice
            winterTires
            contractNumber
            status
            deductible
            windowBreakDeductible
            fsd
            fsdGrowthModel
            fsdGrowthFee
        }
    }
`

@Injectable({
    providedIn: 'root',
})
export class ContractGQL extends Apollo.Query<ContractQuery, ContractQueryVariables> {
    document = ContractDocument

    constructor(apollo: Apollo.Apollo) {
        super(apollo)
    }
}
export const DealCollectionDocument = gql`
    query DealCollection($ownerId: String!) {
        DealCollection(
            filter: {
                AND: [
                    { ownerId: $ownerId }
                    { OR: [{ status: OFFER }, { status: CONTRACT_INCOMPLETE }, { status: CONTRACT_COMPLETE }] }
                ]
            }
            orderBy: { field: "updatedAt", asc: false }
            pagination: { limit: 10 }
        ) {
            deals {
                id
                editionName
                modelName
                pricing {
                    pricePerMonthExVAT
                    pricePerMonthIncVAT
                    incVAT
                }
            }
        }
    }
`

@Injectable({
    providedIn: 'root',
})
export class DealCollectionGQL extends Apollo.Query<DealCollectionQuery, DealCollectionQueryVariables> {
    document = DealCollectionDocument

    constructor(apollo: Apollo.Apollo) {
        super(apollo)
    }
}
export const MyContractsDocument = gql`
    query myContracts {
        myContracts {
            id
            contractNumber
            startDate
            endDate
            winterTires
            mileage
            duration
            status
            car {
                VIN
                licensePlate
                brandName
                modelName
                editionName
            }
        }
    }
`

@Injectable({
    providedIn: 'root',
})
export class MyContractsGQL extends Apollo.Query<MyContractsQuery, MyContractsQueryVariables> {
    document = MyContractsDocument

    constructor(apollo: Apollo.Apollo) {
        super(apollo)
    }
}
export const ConfigurationModelsForCheckoutDocument = gql`
    query ConfigurationModelsForCheckout {
        ConfigurationModels {
            ... on ConfigurationModel {
                id
                editions {
                    id
                    fiscalValue
                }
            }
        }
    }
`

@Injectable({
    providedIn: 'root',
})
export class ConfigurationModelsForCheckoutGQL extends Apollo.Query<
    ConfigurationModelsForCheckoutQuery,
    ConfigurationModelsForCheckoutQueryVariables
> {
    document = ConfigurationModelsForCheckoutDocument

    constructor(apollo: Apollo.Apollo) {
        super(apollo)
    }
}
export const CreateDealDocument = gql`
    mutation createDeal($input: DealInput!) {
        createDeal(input: $input) {
            ...baseDealConfigurationFields
        }
    }
    ${BaseDealConfigurationFieldsFragmentDoc}
`

@Injectable({
    providedIn: 'root',
})
export class CreateDealGQL extends Apollo.Mutation<CreateDealMutation, CreateDealMutationVariables> {
    document = CreateDealDocument

    constructor(apollo: Apollo.Apollo) {
        super(apollo)
    }
}
export const DealByModelIdDocument = gql`
    query DealByModelId($modelId: String!) {
        DealByModelId(modelId: $modelId) {
            ...baseDealConfigurationFields
        }
    }
    ${BaseDealConfigurationFieldsFragmentDoc}
`

@Injectable({
    providedIn: 'root',
})
export class DealByModelIdGQL extends Apollo.Query<DealByModelIdQuery, DealByModelIdQueryVariables> {
    document = DealByModelIdDocument

    constructor(apollo: Apollo.Apollo) {
        super(apollo)
    }
}
export const BanksAvailableForIdealDocument = gql`
    query BanksAvailableForIdeal {
        BanksAvailableForIdeal {
            id
            name
        }
    }
`

@Injectable({
    providedIn: 'root',
})
export class BanksAvailableForIdealGQL extends Apollo.Query<
    BanksAvailableForIdealQuery,
    BanksAvailableForIdealQueryVariables
> {
    document = BanksAvailableForIdealDocument

    constructor(apollo: Apollo.Apollo) {
        super(apollo)
    }
}
export const LookupAddressDocument = gql`
    query LookupAddress($input: LookupAddressInput!) {
        LookupAddress(input: $input) {
            id
            street
            city
        }
    }
`

@Injectable({
    providedIn: 'root',
})
export class LookupAddressGQL extends Apollo.Query<LookupAddressQuery, LookupAddressQueryVariables> {
    document = LookupAddressDocument

    constructor(apollo: Apollo.Apollo) {
        super(apollo)
    }
}
export const AcceptDealOfferDocument = gql`
    mutation acceptDealOffer($id: ID!) {
        acceptDealOffer(id: $id) {
            id
            status
        }
    }
`

@Injectable({
    providedIn: 'root',
})
export class AcceptDealOfferGQL extends Apollo.Mutation<AcceptDealOfferMutation, AcceptDealOfferMutationVariables> {
    document = AcceptDealOfferDocument

    constructor(apollo: Apollo.Apollo) {
        super(apollo)
    }
}
export const AddSigningPersonToDealDocument = gql`
    mutation addSigningPersonToDeal($id: ID!, $email: EmailAddress!) {
        addSigningpersonToDeal(id: $id, email: $email) {
            id
            signingPersons {
                ...SigningPersonFragment
            }
        }
    }
    ${SigningPersonFragmentFragmentDoc}
`

@Injectable({
    providedIn: 'root',
})
export class AddSigningPersonToDealGQL extends Apollo.Mutation<
    AddSigningPersonToDealMutation,
    AddSigningPersonToDealMutationVariables
> {
    document = AddSigningPersonToDealDocument

    constructor(apollo: Apollo.Apollo) {
        super(apollo)
    }
}
export const CreateDealDocumentUploadTokenDocument = gql`
    mutation createDealDocumentUploadToken($id: ID!) {
        createDealDocumentUploadToken(id: $id)
    }
`

@Injectable({
    providedIn: 'root',
})
export class CreateDealDocumentUploadTokenGQL extends Apollo.Mutation<
    CreateDealDocumentUploadTokenMutation,
    CreateDealDocumentUploadTokenMutationVariables
> {
    document = CreateDealDocumentUploadTokenDocument

    constructor(apollo: Apollo.Apollo) {
        super(apollo)
    }
}
export const CreateLegalDocumentAgreementTemplateByNameDocument = gql`
    query createLegalDocumentAgreementTemplateByName(
        $name: String
        $locale: String
        $variables: [LegalDocumentAgreementVariableInput]
    ) {
        createLegalDocumentAgreementTemplate(name: $name, locale: $locale, variables: $variables) {
            hash
            title
            body
            agreement
            summary
            name
            locale
        }
    }
`

@Injectable({
    providedIn: 'root',
})
export class CreateLegalDocumentAgreementTemplateByNameGQL extends Apollo.Query<
    CreateLegalDocumentAgreementTemplateByNameQuery,
    CreateLegalDocumentAgreementTemplateByNameQueryVariables
> {
    document = CreateLegalDocumentAgreementTemplateByNameDocument

    constructor(apollo: Apollo.Apollo) {
        super(apollo)
    }
}
export const DealConfigurationDocument = gql`
    query DealConfiguration($id: ID!) {
        Deal(id: $id) {
            ...baseDealConfigurationFields
        }
    }
    ${BaseDealConfigurationFieldsFragmentDoc}
`

@Injectable({
    providedIn: 'root',
})
export class DealConfigurationGQL extends Apollo.Query<DealConfigurationQuery, DealConfigurationQueryVariables> {
    document = DealConfigurationDocument

    constructor(apollo: Apollo.Apollo) {
        super(apollo)
    }
}
export const DealOfferDocument = gql`
    query DealOffer($id: ID!) {
        Deal(id: $id) {
            ...baseDealFields
            internalOwnerId
            status
            remarks
            optionsDescription
            requirements {
                ...DealRequirementsFragment
            }
        }
    }
    ${BaseDealFieldsFragmentDoc}
    ${DealRequirementsFragmentFragmentDoc}
`

@Injectable({
    providedIn: 'root',
})
export class DealOfferGQL extends Apollo.Query<DealOfferQuery, DealOfferQueryVariables> {
    document = DealOfferDocument

    constructor(apollo: Apollo.Apollo) {
        super(apollo)
    }
}
export const DealContractDocument = gql`
    query DealContract($id: ID!) {
        Deal(id: $id) {
            ...baseDealFields
            requirements {
                ...DealRequirementsFragment
            }
            signingPersons {
                ...SigningPersonFragment
            }
            legalDocumentNames
            internalOwnerId
            contact {
                ...ContactFragment
            }
            billingAccount {
                ...BillingAccountFragment
            }
            manufacturerReferralCode
            manufacturerAccountEmailAddress
            status
            remarks
        }
    }
    ${BaseDealFieldsFragmentDoc}
    ${DealRequirementsFragmentFragmentDoc}
    ${SigningPersonFragmentFragmentDoc}
    ${ContactFragmentFragmentDoc}
    ${BillingAccountFragmentFragmentDoc}
`

@Injectable({
    providedIn: 'root',
})
export class DealContractGQL extends Apollo.Query<DealContractQuery, DealContractQueryVariables> {
    document = DealContractDocument

    constructor(apollo: Apollo.Apollo) {
        super(apollo)
    }
}
export const DealContractPdfDocument = gql`
    query DealContractPdf($dealId: ID!) {
        DealContractPdf(dealId: $dealId) {
            dealId
            url
        }
    }
`

@Injectable({
    providedIn: 'root',
})
export class DealContractPdfGQL extends Apollo.Query<DealContractPdfQuery, DealContractPdfQueryVariables> {
    document = DealContractPdfDocument

    constructor(apollo: Apollo.Apollo) {
        super(apollo)
    }
}
export const EnabledSigningMethodsDocument = gql`
    query enabledSigningMethods($id: ID!) {
        TenantSettings(id: $id) {
            enabledSigningMethods
        }
    }
`

@Injectable({
    providedIn: 'root',
})
export class EnabledSigningMethodsGQL extends Apollo.Query<
    EnabledSigningMethodsQuery,
    EnabledSigningMethodsQueryVariables
> {
    document = EnabledSigningMethodsDocument

    constructor(apollo: Apollo.Apollo) {
        super(apollo)
    }
}
export const MakeDealOfferDocument = gql`
    mutation makeDealOffer($dealId: ID!) {
        makeDealOffer(id: $dealId) {
            id
            status
        }
    }
`

@Injectable({
    providedIn: 'root',
})
export class MakeDealOfferGQL extends Apollo.Mutation<MakeDealOfferMutation, MakeDealOfferMutationVariables> {
    document = MakeDealOfferDocument

    constructor(apollo: Apollo.Apollo) {
        super(apollo)
    }
}
export const SignViaIdealDocument = gql`
    mutation signViaIdeal($id: ID!, $bankId: String!, $callbackPath: String!) {
        signViaIdeal(id: $id, bankId: $bankId, callbackPath: $callbackPath)
    }
`

@Injectable({
    providedIn: 'root',
})
export class SignViaIdealGQL extends Apollo.Mutation<SignViaIdealMutation, SignViaIdealMutationVariables> {
    document = SignViaIdealDocument

    constructor(apollo: Apollo.Apollo) {
        super(apollo)
    }
}
export const SigningPersonsDocument = gql`
    query SigningPersons($id: ID!) {
        Deal(id: $id) {
            id
            signingPersons {
                ...SigningPersonFragment
            }
        }
    }
    ${SigningPersonFragmentFragmentDoc}
`

@Injectable({
    providedIn: 'root',
})
export class SigningPersonsGQL extends Apollo.Query<SigningPersonsQuery, SigningPersonsQueryVariables> {
    document = SigningPersonsDocument

    constructor(apollo: Apollo.Apollo) {
        super(apollo)
    }
}
export const UpdateBooleanDealOptionDocument = gql`
    mutation updateBooleanDealOption($id: ID!, $dealOptionId: ID!, $value: Boolean!) {
        updateBooleanDealOption(id: $id, dealOptionId: $dealOptionId, value: $value) {
            ...baseDealFields
            requirements {
                ...DealRequirementsFragment
            }
        }
    }
    ${BaseDealFieldsFragmentDoc}
    ${DealRequirementsFragmentFragmentDoc}
`

@Injectable({
    providedIn: 'root',
})
export class UpdateBooleanDealOptionGQL extends Apollo.Mutation<
    UpdateBooleanDealOptionMutation,
    UpdateBooleanDealOptionMutationVariables
> {
    document = UpdateBooleanDealOptionDocument

    constructor(apollo: Apollo.Apollo) {
        super(apollo)
    }
}
export const UpdateDealBillingDocument = gql`
    mutation updateDealBilling($id: ID!, $input: DealBillingInput!) {
        updateDealBilling(id: $id, input: $input) {
            id
            billingAccount {
                ...BillingAccountFragment
            }
        }
    }
    ${BillingAccountFragmentFragmentDoc}
`

@Injectable({
    providedIn: 'root',
})
export class UpdateDealBillingGQL extends Apollo.Mutation<
    UpdateDealBillingMutation,
    UpdateDealBillingMutationVariables
> {
    document = UpdateDealBillingDocument

    constructor(apollo: Apollo.Apollo) {
        super(apollo)
    }
}
export const UpdateDealContactDocument = gql`
    mutation updateDealContact($id: ID!, $input: DealContactInput) {
        updateDealContact(id: $id, input: $input) {
            id
            contact {
                ...ContactFragment
            }
        }
    }
    ${ContactFragmentFragmentDoc}
`

@Injectable({
    providedIn: 'root',
})
export class UpdateDealContactGQL extends Apollo.Mutation<
    UpdateDealContactMutation,
    UpdateDealContactMutationVariables
> {
    document = UpdateDealContactDocument

    constructor(apollo: Apollo.Apollo) {
        super(apollo)
    }
}
export const UpdateDealDriverDocument = gql`
    mutation updateDealDriver($id: ID!, $email: String) {
        updateDealDriver(id: $id, email: $email) {
            id
            driver {
                ...DriverFragment
            }
        }
    }
    ${DriverFragmentFragmentDoc}
`

@Injectable({
    providedIn: 'root',
})
export class UpdateDealDriverGQL extends Apollo.Mutation<UpdateDealDriverMutation, UpdateDealDriverMutationVariables> {
    document = UpdateDealDriverDocument

    constructor(apollo: Apollo.Apollo) {
        super(apollo)
    }
}
export const UpdateDealLesseeDocument = gql`
    mutation updateDealLessee($id: ID!, $input: CompanyInput) {
        updateDealLessee(id: $id, input: $input) {
            id
            lessee {
                ... on LesseeCompany {
                    ...LesseeCompanyFragment
                }
                ... on LesseePerson {
                    ...LesseePersonFragment
                }
            }
        }
    }
    ${LesseeCompanyFragmentFragmentDoc}
    ${LesseePersonFragmentFragmentDoc}
`

@Injectable({
    providedIn: 'root',
})
export class UpdateDealLesseeGQL extends Apollo.Mutation<UpdateDealLesseeMutation, UpdateDealLesseeMutationVariables> {
    document = UpdateDealLesseeDocument

    constructor(apollo: Apollo.Apollo) {
        super(apollo)
    }
}
export const UpdateDealManufacturerAccountEmailAddressDocument = gql`
    mutation updateDealManufacturerAccountEmailAddress($id: ID!, $email: EmailAddress!) {
        updateDealManufacturerAccountEmailAddress(id: $id, email: $email) {
            id
            manufacturerAccountEmailAddress
        }
    }
`

@Injectable({
    providedIn: 'root',
})
export class UpdateDealManufacturerAccountEmailAddressGQL extends Apollo.Mutation<
    UpdateDealManufacturerAccountEmailAddressMutation,
    UpdateDealManufacturerAccountEmailAddressMutationVariables
> {
    document = UpdateDealManufacturerAccountEmailAddressDocument

    constructor(apollo: Apollo.Apollo) {
        super(apollo)
    }
}
export const UpdateDealManufacturerReferralCodeDocument = gql`
    mutation updateDealManufacturerReferralCode($id: ID!, $code: String!) {
        updateDealManufacturerReferralCode(id: $id, code: $code) {
            id
            manufacturerReferralCode
        }
    }
`

@Injectable({
    providedIn: 'root',
})
export class UpdateDealManufacturerReferralCodeGQL extends Apollo.Mutation<
    UpdateDealManufacturerReferralCodeMutation,
    UpdateDealManufacturerReferralCodeMutationVariables
> {
    document = UpdateDealManufacturerReferralCodeDocument

    constructor(apollo: Apollo.Apollo) {
        super(apollo)
    }
}
export const UpdateDealReferralCodeDocument = gql`
    mutation updateDealReferralCode($id: ID!, $code: String!) {
        updateDealReferralCode(id: $id, code: $code) {
            id
            referralCode
            referralProgram {
                id
                name
            }
            pricing {
                ...PricingFragment
            }
        }
    }
    ${PricingFragmentFragmentDoc}
`

@Injectable({
    providedIn: 'root',
})
export class UpdateDealReferralCodeGQL extends Apollo.Mutation<
    UpdateDealReferralCodeMutation,
    UpdateDealReferralCodeMutationVariables
> {
    document = UpdateDealReferralCodeDocument

    constructor(apollo: Apollo.Apollo) {
        super(apollo)
    }
}
export const UpdateSelectableDealOptionDocument = gql`
    mutation updateSelectableDealOption($id: ID!, $dealOptionId: ID!, $valueId: ID!) {
        updateSelectableDealOption(id: $id, dealOptionId: $dealOptionId, valueId: $valueId) {
            ...baseDealFields
            requirements {
                ...DealRequirementsFragment
            }
        }
    }
    ${BaseDealFieldsFragmentDoc}
    ${DealRequirementsFragmentFragmentDoc}
`

@Injectable({
    providedIn: 'root',
})
export class UpdateSelectableDealOptionGQL extends Apollo.Mutation<
    UpdateSelectableDealOptionMutation,
    UpdateSelectableDealOptionMutationVariables
> {
    document = UpdateSelectableDealOptionDocument

    constructor(apollo: Apollo.Apollo) {
        super(apollo)
    }
}
export const UploadDocumentDocument = gql`
    mutation uploadDocument($input: DocumentInput!) {
        uploadDocument(input: $input) {
            id
        }
    }
`

@Injectable({
    providedIn: 'root',
})
export class UploadDocumentGQL extends Apollo.Mutation<UploadDocumentMutation, UploadDocumentMutationVariables> {
    document = UploadDocumentDocument

    constructor(apollo: Apollo.Apollo) {
        super(apollo)
    }
}
export const UserProfileDocument = gql`
    query UserProfile($userId: ID) {
        UserProfile(userId: $userId) {
            id
            firstName
            emailAddress
            telephoneNumber
        }
    }
`

@Injectable({
    providedIn: 'root',
})
export class UserProfileGQL extends Apollo.Query<UserProfileQuery, UserProfileQueryVariables> {
    document = UserProfileDocument

    constructor(apollo: Apollo.Apollo) {
        super(apollo)
    }
}
